{
  "LogbookApp_version_major": "1.1",

  "RecordingClockWarning_title": "Warnung zur Aufzeichnungszeit",
  "RecordingClockWarning_acknowledge": "Bestätigen",
  "RecordingClockWarning_system": "Die Computeruhr ist unzuverlässig. Die Aufzeichnung wird mit der GPS-Zeit fortgesetzt.",
  "RecordingClockWarning_gps": "Die GPS-Uhr ist unzuverlässig. Die Aufzeichnung wird mit der Computerzeit fortgesetzt.",
  "RecordingClockWarning_paused": "Keine zuverlässige Zeitquelle verfügbar. Automatische Aufzeichnung und neue Einträge zur aktuellen Zeit sind pausiert, bis GPS oder Computeruhr wieder zuverlässig sind. Frühere Einträge können weiterhin bearbeitet werden.",

  "Layout": "",
  "Layout_documentation": "DOKUMENTATION",
  "Layout_support": "Support",

  "OpenServerDialog_title": "LOGBOOK Cloud öffnen",
  "OpenServerDialog_opening": "LOGBOOK Cloud wird geöffnet...",
  "OpenServerDialog_failed": "LOGBOOK Cloud konnte nicht geöffnet werden. Prüfe die Verbindung und erlaube Pop-up-Fenster. Versuche es dann erneut.",
  "OpenServerDialog_close": "Schließen",
  "OpenServerDialog_retry": "Erneut versuchen",

  "AboutView": "",
  "AboutView_title": "Über LOGBOOK",
  "AboutView_version": "Version",
  "AboutView_website": "Website",
  "AboutView_support": "Support",
  "AboutView_copyright": "Copyright © 2026 by Trimutic UG",
  "AboutView_uploadAppData": "App-Daten an Support hochladen",
  "AboutView_uploadAppDataUploading": "Wird hochgeladen…",
  "AboutView_uploadAppDataSuccess": "App-Daten hochgeladen",
  "AboutView_uploadAppDataError": "App-Daten konnten nicht hochgeladen werden",

  "AccountView": "",
  "AccountView_cancel": "Abbrechen",
  "AccountView_cancel_plan": "Abo kündigen",
  "AccountView_currency": "Währung",
  "AccountView_currency_EUR": "Euro (€)",
  "AccountView_currency_USD": "US Dollar ($)",
  "AccountView_duration": "Laufzeit",
  "AccountView_duration_5": "5 Tage",
  "AccountView_duration_30": "monatliche\u00A0Abbuchung, monatlich\u00A0kündbar",
  "AccountView_duration_120": "4 Monate",
  "AccountView_duration_365": "jährliche\u00A0Abbuchung, jährlich\u00A0kündbar",
  "AccountView_duration_30_iap": "monatliche\u00A0Abbuchung, verlängert sich\u00A0automatisch, sofern nicht\u00A0gekündigt",
  "AccountView_feature_active_ships": "Aktive Schiffe: {amount}",
  "AccountView_feature_active_users": "Aktive Benutzer: {amount}",
  "AccountView_feature_active_tenders": "Aktive Tender: {amount}",
  "AccountView_feature_support_1": "Standard-Support",
  "AccountView_feature_support_10": "Pro-Support",
  "AccountView_feature_support_100": "Master-Support",
  "AccountView_feature_unlimited": "Unbegrenzt",
  "AccountView_pay": "Wiederkehrende Zahlung von {price} bestätigen",
  "AccountView_pay_cancel": "Abbrechen",
  "AccountView_pay_processing": "Zahlung wird verarbeitet...",
  "AccountView_payment_information": "Zahlungsinformationen",
  "AccountView_payment_title": "{plan} Abonnement für {price}",
  "AccountView_plans": "Unsere Abonnement-Pläne",
  "AccountView_plans_iPad": "Dein Abo für LOGBOOK",
  "AccountView_plan_captain": "LOGBOOK Captain",
  "AccountView_plan_master_captain": "LOGBOOK Master Captain",
  "AccountView_plan_skipper": "LOGBOOK Skipper",
  "AccountView_plan_trial": "LOGBOOK Trial",
  "AccountView_price_duration_5": "5 Tage",
  "AccountView_price_duration_30": "Monat",
  "AccountView_price_duration_365": "Jahr",
  "AccountView_price_free": "Kostenlos",
  "AccountView_price_EUR": "{price} € pro {duration}",
  "AccountView_price_USD": "${price} pro {duration}",
  "AccountView_price_native": "{price} pro {duration}",
  "AccountView_price_or_monthly": " oder ",
  "AccountView_select_plan": "Plan auswählen",
  "AccountView_subscribe": "Abonnieren",
  "AccountView_subscribe_api": "Abonnieren",
  "AccountView_time_left": "Noch {days} Tage",
  "AccountView_renews_in": "Verlängert sich in {days} Tagen",
  "AccountView_cancelled_ends": "Gekündigt — Zugang endet in {days} Tagen",
  "AccountView_apple_cancel_info_title": "Abo verwalten",
  "AccountView_apple_cancel_info_message": "Dieses Abo wurde über den App Store abgeschlossen und muss dort verwaltet werden. Öffne auf deinem iPhone oder iPad die Einstellungen, tippe auf deinen Namen, dann auf Abonnements, wähle LOGBOOK und kündige es dort. Dein Zugang bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv.",
  "AccountView_taxes": "Inkl. Steuern",
  "AccountView_terms_of_use": "Nutzungsbedingungen",
  "AccountView_privacy_policy": "Datenschutzerklärung",
  "AccountView_restore_purchases": "Käufe wiederherstellen",
  "AccountView_restore_purchases_running": "Wird wiederhergestellt …",
  "AccountView_restore_nothing_title": "Keine Käufe gefunden",
  "AccountView_restore_nothing_message": "Auf dieser Apple-ID gibt es kein aktives Abo, das wiederhergestellt werden kann.",
  "AccountView_restore_claim_title": "Abo verschieben",
  "AccountView_restore_claim_message": "Das Abo dieser Apple-ID ist derzeit mit „{account}“ verknüpft. Zu „{current}“ verschieben? „{account}“ verliert dadurch den Zugriff.",
  "AccountView_restore_claim_confirm": "Hierher verschieben",
  "AccountView_restore_claim_cancel": "Dort belassen",
  "AccountView_linked_to_other_account": "Das Abo dieser Apple-ID ist mit dem LOGBOOK-Konto „{account}“ verknüpft.",
  "AccountView_linked_to_other_account_hint": "Verschiebe es über „Käufe wiederherstellen“ in dieses Konto, oder zahle im Web per Karte.",
  "AccountView_title": "Account-Einstellungen",
  "AccountView_total": "Gesamtbetrag",

  "AccountSettingsView_alert_no_internet_title": "Keine Internet-Verbindung verfügbar",
  "AccountSettingsView_alert_no_internet_text": "Eine Internet-Verbindung ist erforderlich, um die Account-Einstellungen zu ändern.",

  "AccountSettingsView_error_passwordInvalid": "Das Passwort stimmt nicht mit dem aktuellen überein.",
  "AccountSettingsView_error_passwordConfirmationMismatch": "Passwortbestätigung stimmt nicht mit dem Passwort überein.",
  "AccountSettingsView_error_Not Found": "Nicht gefunden",
  "AccountSettingsView_error_accountUserSelfAction": "Du kannst deine eigenen Berechtigungen nicht ändern, deaktivieren oder entfernen.",
  "AccountSettingsView_error_accountUserLastAdmin": "Der Account muss mindestens einen aktiven Admin haben.",
  "AccountSettingsView_error_account_user_action_failed": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  "AccountSettingsView_error_account_update_failed": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  "AccountSettingsView_change_password": "Passwort ändern",
  "AccountSettingsView_confirm_new_password": "Neue Passwort bestätigen",
  "AccountSettingsView_current_password": "Aktuelles Passwort",
  "AccountSettingsView_new_password": "Neues Passwort",

  "AccountSettingsView_import_ship": "Aus LogbookSuite importieren",
  "AccountSettingsView_import_trips": "Etappen für \"{name}\" aus LogbookSuite importieren",
  "AccountSettingsView_new_ship": "Mit einem neuen Schiff beginnen",
  "AccountSettingsView_select_ship": "Aus deinen Schiffen auswählen",
  "AccountSettingsView_select_shared_ship": "Aus geteilten Schiffen auswählen",
  "AccountSettingsView_deselect_ship": "Schiff schließen",
  "AccountSettingsView_add_new_ship": "Neues Schiff hinzufügen",
  "AccountSettingsView_users_list": "Liste aller User in deinem Account",

  "AccountSettingsView_tab_ships": "Deine Schiffe",
  "AccountSettingsView_tab_subscription": "Dein Abonnement",
  "AccountSettingsView_tab_users": "Deine User",

  "AccountSettingsView_ship_open_here_notice": "Schließe das auf diesem Gerät geöffnete LOGBOOK, um ein anderes Schiff auszuwählen.",
  "AccountSettingsView_companion_reconnect_notice": "Die Verbindung zum Primary LOGBOOK wurde unterbrochen — seine Adresse in diesem Netzwerk hat sich möglicherweise geändert. Verbinde dich erneut, um fortzufahren.",
  "AccountSettingsView_ship_close_companion": "LOGBOOK Companion trennen",
  "AccountSettingsView_ship_close_confirm": "LOGBOOK schließen",
  "AccountSettingsView_ship_logbook": "LOGBOOK für \"{name}\" anzeigen",

  "AccountSettingsView_account_data": "Deine Account-Daten",
  "AccountSettingsView_account_edit_cancel": "Abbrechen",
  "AccountSettingsView_account_edit_save": "Speichern",
  "AccountSettingsView_account_login": "Anmeldename (E-Mail)",
  "AccountSettingsView_account_name": "Account Name",
  "AccountSettingsView_account_settings": "Account-Einstellungen",
  "AccountSettingsView_account_user_level": "Berechtigungen",
  "AccountSettingsView_account_user_level_admin": "Admin",
  "AccountSettingsView_account_user_level_user": "User",
  "AccountSettingsView_account_user_level_disabled": "Deaktiviert",
  "AccountSettingsView_deactivate_user": "Deaktivieren",
  "AccountSettingsView_reactivate_user": "Reaktivieren",
  "AccountSettingsView_remove_user": "Entfernen",
  "AccountSettingsView_user_deactivate_confirm_title": "User deaktivieren",
  "AccountSettingsView_user_deactivate_confirm_message": "Dieser User hat noch Zugriff auf ein Schiff in diesem Account. Möchtest du seinen Account wirklich deaktivieren?",
  "AccountSettingsView_user_deactivate_confirm_accept": "Deaktivieren",
  "AccountSettingsView_user_deactivate_confirm_cancel": "Abbrechen",
  "AccountSettingsView_user_remove_confirm_title": "User entfernen",
  "AccountSettingsView_user_remove_confirm_message": "Dieser User hat noch Zugriff auf ein Schiff in diesem Account. Möchtest du ihn wirklich aus dem Account entfernen? Dies kann nicht rückgängig gemacht werden.",
  "AccountSettingsView_user_remove_confirm_accept": "Entfernen",
  "AccountSettingsView_user_remove_confirm_cancel": "Abbrechen",
  "AccountSettingsView_change_plan": "Plan ändern",
  "AccountSettingsView_customer_name": "Name",
  "AccountSettingsView_edit_account": "Account bearbeiten",
  "AccountSettingsView_remove_account": "Account löschen",
  "AccountSettingsView_plan": "Dein aktueller Plan",
  "AccountSettingsView_plans": "LOGBOOK Pläne",
  "AccountSettingsView_subscription": "Dein Abonnement",
  "AccountSettingsView_user_account": "Account",
  "AccountSettingsView_user_name": "Name",
  "AccountSettingsView_user_email": "E-Mail",
  "AccountSettingsView_user_shortname": "Kurzname",
  "AccountSettingsView_user_status": "Status",
  "AccountSettingsView_user_status_active": "Aktiv",
  "AccountSettingsView_user_status_invited": "Eingeladen",
  "AccountSettingsView_user_permissions": "Berechtigungen",
  "AccountSettingsView_current_ship": "Dein aktuelles Schiff ist {name}",
  "AccountSettingsView_no_current_ship": "Kein Schiff ausgewählt",
  "AccountSettingsView_valid_until": "Gültig bis",
  "AccountSettingsView_trial_days_remaining": "Verbleibende Trial-Tage",
  "AccountSettingsView_trial_days_value": "{days} Tage",

  "AccountSettingsView_user_crew_role": "Crew-Rolle",
  "AccountSettingsView_ship_user_crew_role_crew": "Crew",
  "AccountSettingsView_ship_user_crew_role_none": "Keine",
  "AccountSettingsView_ship_user_crew_role_owner": "Account-Inhaber",
  "AccountSettingsView_ship_user_crew_role_skipper": "Skipper",

  "AccountSettingsView_ship_user_level": "Berechtigungen",
  "AccountSettingsView_ship_user_level_primary": "Primär",
  "AccountSettingsView_ship_user_level_editAll": "Alles ansehen und bearbeiten",
  "AccountSettingsView_ship_user_level_editCurrent": "Aktuellen Törn ansehen und bearbeiten",
  "AccountSettingsView_ship_user_level_viewAll": "Alles ansehen",
  "AccountSettingsView_ship_user_level_viewCurrent": "Aktuellen Törn ansehen",
  "AccountSettingsView_ship_user_level_none": "Keine",

  "AppDisconnectedView": "",
  "AppDisconnectedView_connection_overlay_reload": "Neu laden",
  "AppDisconnectedView_connection_overlay_reloading": "Wird neu geladen …",
  "AppDisconnectedView_connection_overlay_title": "Verbindung unterbrochen",
  "AppDisconnectedView_disconnect_companion": "LOGBOOK Companion trennen",

  "AppHeaderView": "",

  "AppOverlayContentView": "",
  "AppOverlayContentView_cancel": "Abbrechen",
  "AppOverlayContentView_connect_logbook": "Mit Primary LOGBOOK verbinden",
  "AppOverlayContentView_connect_logbook_title": "Mit Primary LOGBOOK von \"{name}\" verbinden",
  "AppOverlayContentView_connect_logbook_failed": "Verbindung mit Primary LOGBOOK fehlgeschlagen",
  "AppOverlayContentView_connect_logbook_connecting": "Verbindung mit dem Primary LOGBOOK für \"{name}\" wird hergestellt…",
  "AppOverlayContentView_connect_logbook_connecting_short": "Verbinden…",
  "AppOverlayContentView_connect_logbook_timeout": "\"{name}\" konnte nicht automatisch erreicht werden — bitte Adresse eingeben",
  "AppOverlayContentView_connect_logbook_not_discovered": "„{name}“ ist in diesem Netzwerk nicht sichtbar. Prüfe, ob beide Geräte im selben WLAN sind, oder gib die Adresse unten ein.",
  "AppOverlayContentView_connect_logbook_ambiguous": "Mehrere Geräte bieten „{name}“ an. Gib die Adresse des gewünschten Geräts ein.",
  "AppOverlayContentView_connect_logbook_unresolved": "„{name}“ wurde gefunden, aber die Adresse konnte nicht ermittelt werden. Bitte unten eingeben.",
  "AppOverlayContentView_connect_logbook_unreachable": "Keine Antwort von „{name}“ unter {address}. Prüfe die Adresse und ob beide Geräte im selben Netzwerk sind.",
  "AppOverlayContentView_connect_logbook_refused": "„{name}“ hat die Verbindung abgelehnt. Stelle sicher, dass der Benutzer dieses Geräts Zugriff auf das Logbuch hat.",
  "AppOverlayContentView_connect_logbook_not_claimed": "„{name}“ ist derzeit nicht auf dem Primary LOGBOOK geöffnet. Öffne es dort und versuche es erneut.",
  "AppOverlayContentView_connect_logbook_not_accessible": "Du hast keinen Zugriff auf „{name}“.",
  "AppOverlayContentView_connect_logbook_address_invalid": "Gib die Adresse als host:port an, zum Beispiel 192.168.1.20:18092.",
  "AppOverlayContentView_connect_logbook_own_device": "„{name}“ ist das eigene Logbuch dieses Geräts — öffne es, statt dich zu verbinden.",
  "AppOverlayContentView_connect_logbook_outdated_title": "Diese App ist nicht aktuell",
  "AppOverlayContentView_connect_logbook_outdated": "Das Primary LOGBOOK von \"{name}\" verwendet eine neuere Version als dieses Gerät. Aktualisiere LOGBOOK hier, um eine Verbindung herzustellen.",
  "AppOverlayContentView_connect_logbook_outdated_version": "Dieses Gerät verwendet Version {version}.",
  "AppOverlayContentView_connect_logbook_outdated_appstore": "Bitte aktualisiere LOGBOOK im App Store.",
  "AppOverlayContentView_connect_logbook_outdated_playstore": "Bitte aktualisiere LOGBOOK im Play Store.",
  "AppOverlayContentView_connect_logbook_outdated_download": "Neueste Version herunterladen",
  "AppOverlayContentView_connection": "Trage hier die IP und den Port des Primary LOGBOOK ein, um eine Verbindung herzustellen. Verwende die Form \"IP:Port\", z.B. \"192.168.0.100:8000\".",
  "AppOverlayContentView_connection_host": "Host",
  "AppOverlayContentView_connection_port": "Port",
  "AppOverlayContentView_disconnect_logbook": "Primary LOGBOOK trennen",
  "AppOverlayContentView_disconnect_ship": "Schiff trennen",
  "AppOverlayContentView_disconnect_ship_title": "Schiff von LOGBOOK Cloud trennen",
  "AppOverlayContentView_import_reset": "Alle importierten Daten zurücksetzen",
  "AppOverlayContentView_import_reset_confirm_title": "Alle importierten Daten zurücksetzen?",
  "AppOverlayContentView_import_reset_confirm_text": "Alle importierten Törns werden dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
  "AppOverlayContentView_import_reset_confirm_no": "Abbrechen",
  "AppOverlayContentView_import_reset_confirm_yes": "Ja, zurücksetzen",
  "AppOverlayContentView_import_resetting": "Wird zurückgesetzt…",
  "AppOverlayContentView_import_ship_cancel": "Abbrechen",
  "AppOverlayContentView_import_ship_choose": "Datei auswählen",
  "AppOverlayContentView_import_ship_title": "Aus Logbook Suite importieren",
  "AppOverlayContentView_import_trips": "Import aus Logbook Suite",
  "AppOverlayContentView_import_status_in_progress": "Import läuft seit {time}",
  "AppOverlayContentView_import_status_complete": "Import abgeschlossen am {date}",
  "AppOverlayContentView_import_status_failed": "Vorheriger Importversuch fehlgeschlagen. Bitte versuche es erneut oder kontaktiere den Support.",
  "AppOverlayContentView_options_cruises": "Törns insgesamt in LOGBOOK:",
  "AppOverlayContentView_options_days": "Tage insgesamt in LOGBOOK:",
  "AppOverlayContentView_options_first_day": "Erster Tag in LOGBOOK:",
  "AppOverlayContentView_options_last_day": "Letzter Tag in LOGBOOK:",
  "AppOverlayContentView_options_trips": "Etappen insgesamt in LOGBOOK:",
  "AppOverlayContentView_options_ship": "Optionen für \"{name}\"",
  "AppOverlayContentView_options_ship_title": "Info zum Schiff",
  "AppOverlayContentView_options_update": "Letzte Synchronisation:",
  "AppOverlayContentView_logout_confirm": "Ausloggen",
  "AppOverlayContentView_logout_confirm_cancel": "Abbrechen",
  "AppOverlayContentView_logout_confirm_title": "Logout bestätigen",
  "AppOverlayContentView_remove_account_cancel": "Abbrechen",
  "AppOverlayContentView_remove_account_confirm": "Bestätigen",
  "AppOverlayContentView_remove_account_confirm_title": "Account löschen",
  "AppOverlayContentView_session_expired_dismiss": "Ohne Synchronisation weiterarbeiten",
  "AppOverlayContentView_session_expired_email": "E-Mail",
  "AppOverlayContentView_session_expired_failed": "Login fehlgeschlagen. Bitte prüfe E-Mail und Passwort und versuche es erneut.",
  "AppOverlayContentView_session_expired_failed_request": "Der Login konnte nicht gesendet werden. Bitte prüfe die Internetverbindung und versuche es erneut.",
  "AppOverlayContentView_session_expired_login": "Einloggen",
  "AppOverlayContentView_session_expired_login_loading": "Login läuft…",
  "AppOverlayContentView_session_expired_password": "Passwort",
  "AppOverlayContentView_session_expired_title": "Login erforderlich",
  "AppOverlayContentView_ship_close_confirm": "Schließen von LOGBOOK bestätigen",
  "AppOverlayContentView_ship_close_confirm_cancel": "Abbrechen",
  "AppOverlayContentView_ship_close_confirm_closing": "LOGBOOK wird geschlossen…",
  "AppOverlayContentView_ship_close_confirm_title": "Schließen des Schiffs bestätigen",
  "AppOverlayContentView_ship_close_failed": "LOGBOOK konnte nicht geschlossen werden. Prüfe die Internetverbindung und versuche es erneut.",
  "AppOverlayContentView_ship_close_failed_offline": "LOGBOOK konnte nicht geschlossen werden, weil dieses Gerät offline ist. Prüfe die Internetverbindung und versuche es erneut, oder schließe nur lokal.",
  "AppOverlayContentView_ship_close_failed_server": "LOGBOOK konnte nicht geschlossen werden, weil die LOGBOOK Cloud vorübergehend nicht erreichbar ist. Bitte versuche es gleich noch einmal.",
  "AppOverlayContentView_ship_force_close": "Nur lokal schließen",
  "AppOverlayContentView_ship_force_close_confirm": "Lokales Schließen bestätigen",
  "AppOverlayContentView_ship_view_ships_cloud": "Schiffsliste in Cloud anzeigen",
  "AppOverlayContentView_ships_cloud": "Schiffsliste in Cloud anzeigen",
  "AppOverlayContentView_user_settings": "User-Einstellungen",
  "AppOverlayContentView_ship_not_closed_title": "Primary LOGBOOK \"{name}\" von der LOGBOOK Cloud trennen",
  "AppOverlayContentView_ship_open_title": "Das Primary LOGBOOK für \"{name}\" ist schon geöffnet",
  "AppOverlayContentView_read_more": "Weiterlesen",

  "ChangeLogView_change_log": "Änderungsprotokoll",
  "ChangeLogView_download": "Herunterladen",
  "ChangeLogView_change_welcome": "Willkommen zur LOGBOOK App Version {version}!",
  "ChangeLogView_change_fixed_info": "Hier findest du Informationen zu allen vorgenommenen Änderungen. Das Änderungsprotokoll-Fenster wird bei jedem Neuladen der App angezeigt, wenn neue Änderungen vorliegen.",
  "ChangeLogView_new_version_available": "Neues Update zum Download verfügbar",
  "ChangeLogView_title": "Was ist neu in LOGBOOK",

  "Component_ToggleSwitch": "",
  "Component_ToggleSwitch_off": "AUS",
  "Component_ToggleSwitch_on": "EIN",

  "CruiseCalendarView": "",
  "CruiseCalendarView_actions_print": "Drucken",
  "CruiseCalendarView_focus": "Fokus",
  "CruiseCalendarView_start_ship": "Das neue Schiff in der LOGBOOK-App öffnen",
  "CruiseCalendarView_open_in_cloud": "In Cloud öffnen",
  "CruiseCalendarView_untitled_cruise": "Törn ohne Namen",

  "CruiseEditView_title": "Name des Törns",

  "CruiseView": "",
  "CruiseView_actions_print": "Drucken",
  "CruiseView_empty": "Etappe erstellen, um fortzufahren",
  "CruiseView_menu_labels": "Filter",
  "CruiseView_menu_toggle_labels_off": "Labels aus",
  "CruiseView_menu_toggle_labels_on": "Labels ein",
  "CruiseView_tab_cruise": "Törn",
  "CruiseView_tab_stats": "Statistik",
  "CruiseView_tab_track": "Track",
  "CruiseView_tab_print": "Drucken",
  "CruiseView_print_cruise": "Diesen Törn drucken",
  "CruiseView_untitled_cruise": "Törn ohne Namen",

  "DayEditView": "",
  "DayEditView_comment": "Bemerkung",
  "DayEditView_crew": "Crew",
  "DayEditView_end_location": "Zielort",
  "DayEditView_passengers": "Passagiere",
  "DayEditView_skipper": "Skipper",
  "DayEditView_start_location": "Startort",
  "DayEditView_status_day": "Tag",
  "DayEditView_status_overnight": "Übernachtung",
  "DayEditView_sunrise": "Sonnenaufgang",
  "DayEditView_sunset": "Sonnenuntergang",
  "DayEditView_timezone": "Zeitzone",
  "DayEditView_other_skipper": "Neuer Skipper",
  "DayEditView_other_crew": "Neue Person",
  "DayEditView_save_error_generic": "Nicht gespeichert. Bitte erneut versuchen.",
  "DayEditView_details_last_edited_by": "Zuletzt bearbeitet von {name}",
  "DayEditView_details_last_edited": "Zuletzt bearbeitet",

  "DayHeaderView": "",
  "DayHeaderView_today": "Heute",
  "DayHeaderView_nextDay": "Nächster Tag",
  "DayHeaderView_yesterday": "Gestern",

  "DayView": "",
  "DayView_logs_empty": "Noch keine Log-Einträge",
  "DayView_logs_empty_past": "Keine Log-Einträge",
  "DayView_tab_day": "Tag",
  "DayView_tab_stats": "Statistik",
  "DayView_tab_track": "Track",
  "DayView_tab_watches": "Wachplan",
  "DayView_tab_weather": "Wetter",
  "DayView_tab_weather_forecast": "Wettervorhersage",
  "DayView_tab_journal": "Journal",
  "DayView_tab_technical": "Technik",
  "DayView_tab_print": "Drucken",
  "DayView_print_days": "Alle Tage dieser Etappe drucken",
  "DayView_print_day": "Diesen Tag drucken",

  "DayWatchView": "",
  "DayWatchView_groups_title": "Gruppen für Wachen",
  "DayWatchView_add_group": "Gruppe hinzufügen",
  "DayWatchView_groups_name": "Wachgruppen-Name",
  "DayWatchView_groups_people": "Crew-Mitglieder",

  "DayWatchView_shifts_title": "Wachplan",
  "DayWatchView_shifts_hour": "Stunde",
  "DayWatchView_shifts_duration": "Dauer (h)",
  "DayWatchView_shifts_group": "Wachgruppe",
  "DayWatchView_shifts_group_undefined": "*Auswählen*",
  "DayWatchView_add_shift": "Wachschicht hinzufügen",
  "DayWatchView_reset_shifts": "Wachschichten zurücksetzen",
  "DayWatchView_shifts_unit_hour": "h",

  "EditHistory": "",
  "EditHistory_title": "Verlauf der Änderungen",
  "EditHistory_field": "Feld",
  "EditHistory_previous": "Vorher",
  "EditHistory_new": "Neu",
  "EditHistory_changed": "Geändert",
  "EditHistory_entry_meta": "{date} von {name}",

  "FocusView": "",
  "FocusView_actions_add_cruise": "Törn",
  "FocusView_actions_add_trip": "Etappe",
  "FocusView_actions_complete_cruise": "Törn",
  "FocusView_actions_complete_trip": "Etappe",
  "FocusView_actions_print": "Drucken",
  "FocusView_start_trip": "Etappe starten",
  "FocusView_cancel": "Abbrechen",
  "FocusView_close": "Schließen",
  "FocusView_confirm": "Fortfahren",
  "FocusView_confirm_cruise_title": "Neuen Törn starten",
  "FocusView_confirm_trip_title": "Neue Etappe starten",
  "FocusView_set_timezone": "Zeitzone festlegen",
  "FocusView_tile_new_trip": "Eine neue Etappe starten",
  "FocusView_timezone": "Zeitzone für die Etappe festgelegt",
  "FocusView_current_time": "Berechnete aktuelle Zeit",
  "FocusView_subscription_expired": "Abonnement abgelaufen",
  "FocusView_trial_expired": "Trial-Phase abgelaufen",
  "FocusView_view_plans": "Abonnement-Pläne anzeigen",

  "GraphView": "",
  "GraphView_graph_pressure": "Luftdruck",
  "GraphView_graph_temperature": "Temperatur",
  "GraphView_graph_windDirection": "Windrichtung",
  "GraphView_graph_windDirection_unit": "{direction}°",
  "GraphView_graph_windSpeed": "Windgeschwindigkeit",
  "GraphView_no_data": "Keine Daten",

  "InstrumentsView": "",
  "InstrumentsView_compass_title": "Kompass",
  "InstrumentsView_compass_title_magnetic": "Kompass (mag.)",
  "InstrumentsView_compass_title_true": "Kompass (wahr)",
  "InstrumentsView_course_title": "Kurs",
  "InstrumentsView_depth_title": "Tiefe",
  "InstrumentsView_depth_title_DBK": "Unter Kiel",
  "InstrumentsView_depth_title_DBS": "Unter Oberfläche",
  "InstrumentsView_depth_title_DBT": "Unter Geber",
  "InstrumentsView_depth_title_DPT": "Wasser",
  "InstrumentsView_engine_title_single": "Motor",
  "InstrumentsView_engine_title_multiple": "Motoren",
  "InstrumentsView_nmea_lost_title": "NMEA-Verbindung verloren",
  "InstrumentsView_speed_title": "Geschw.",
  "InstrumentsView_wind_title": "Wind",
  "InstrumentsView_wind_title_apparent": "Scheinbar",
  "InstrumentsView_wind_title_true": "Wahr",
  "InstrumentsView_wind_title_trueRelative": "Wahr (rel.)",
  "InstrumentsView_wind_side_port": "Bb",
  "InstrumentsView_wind_side_starboard": "Stb",

  "LogEnvironmentView": "",
  "LogEnvironmentView_current_direction_speed": "Strömung: Richtung | Geschwind.",
  "LogEnvironmentView_pressure": "Luftdruck",
  "LogEnvironmentView_save_error_fields": "Nicht gespeichert — nicht erlaubt: {fields}",
  "LogEnvironmentView_save_error_generic": "Nicht gespeichert. Bitte erneut versuchen.",

  "LogEnvironmentView_seastate": "Seegang",
  "LogEnvironmentView_seastate_undefined": " ",
  "LogEnvironmentView_seastate_": " ",

  "LogEnvironmentView_seastate_0": "0 Ruhig (spiegelglatt)",
  "LogEnvironmentView_seastate_1": "1 Ruhig (gekräuselt) < 0,1m",
  "LogEnvironmentView_seastate_2": "2 Glatt (kleine Wellen) < 0,5m",
  "LogEnvironmentView_seastate_3": "3 Leicht < 1,25m",
  "LogEnvironmentView_seastate_4": "4 Mäßig < 2,5m",
  "LogEnvironmentView_seastate_5": "5 Rau < 4m",
  "LogEnvironmentView_seastate_6": "6 Sehr rau < 6m",
  "LogEnvironmentView_seastate_7": "7 Hoch < 9m",
  "LogEnvironmentView_seastate_8": "8 Sehr hoch < 14m",
  "LogEnvironmentView_seastate_9": "9 Phänomenal > 14m",
  "LogEnvironmentView_seastate_10": "Verwirrter Seegang",
  "LogEnvironmentView_other": "Neuer Seegang",

  "LogEnvironmentView_current_direction_undefined": " ",
  "LogEnvironmentView_current_direction_": " ",
  "LogEnvironmentView_current_direction_0": "0°",
  "LogEnvironmentView_current_direction_1": "90°",
  "LogEnvironmentView_current_direction_2": "180°",
  "LogEnvironmentView_current_direction_3": "270°",
  "LogEnvironmentView_other_direction": "Andere Richtung",

  "LogEnvironmentView_weather_": "   ",
  "LogEnvironmentView_weather_field": "Wetter",
  "LogEnvironmentView_weather_1": "klarer Himmel",
  "LogEnvironmentView_weather_2": "schön",
  "LogEnvironmentView_weather_3": "halb bewölkt",
  "LogEnvironmentView_weather_4": "bewölkt",
  "LogEnvironmentView_weather_5": "bedeckt",
  "LogEnvironmentView_weather_6": "Nieselregen",
  "LogEnvironmentView_weather_7": "mäßiger Regen",
  "LogEnvironmentView_weather_8": "starker Regen",
  "LogEnvironmentView_weather_9": "Regenschauer",
  "LogEnvironmentView_weather_10": "Diesig",
  "LogEnvironmentView_weather_11": "Nebel",
  "LogEnvironmentView_weather_12": "Dunst",
  "LogEnvironmentView_weather_13": "Schneeregen",
  "LogEnvironmentView_weather_14": "Hagel",
  "LogEnvironmentView_weather_15": "Gewitter",
  "LogEnvironmentView_weather_16": "Schnee",
  "LogEnvironmentView_weather_temp_rel_humidity": "Wetter | Temp. | Rel. Luftfeuchtigkeit",
  "LogEnvironmentView_weather_temp": "Lufttemperatur",
  "LogEnvironmentView_weather_rel_humidity": "Relative Luftfeuchtigkeit",
  "LogEnvironmentView_wind_direction_speed": "Wind: Richtung | Geschwindigkeit",

  "LogNavigationView": "",
  "LogNavigationView_comment": "Bemerkung",
  "LogNavigationView_course": "Kurs",
  "LogNavigationView_course_to_wind": "Kurs zum Wind",
  "LogNavigationView_point_of_sail_noGo": "Im Wind",
  "LogNavigationView_point_of_sail_closeHauled": "Am Wind",
  "LogNavigationView_point_of_sail_beamReach": "Halbwind",
  "LogNavigationView_point_of_sail_broadReach": "Raum",
  "LogNavigationView_point_of_sail_running": "Vorwind",
  "LogNavigationView_wind_side_port": "Bb",
  "LogNavigationView_wind_side_starboard": "Stb",
  "LogNavigationView_depth": "Tiefe",
  "LogNavigationView_distance": "Distanz",
  "LogNavigationView_engine": "Motor",
  "LogNavigationView_engines": "Motoren",
  "LogNavigationView_engine_name": "Motor {name}",
  "LogNavigationView_heading": "Heading",
  "LogNavigationView_location": "Ort während Stopp",
  "LogNavigationView_log": "Log",
  "LogNavigationView_position": "Position: Lat | Lon",
  "LogNavigationView_sails": "Segel",
  "LogNavigationView_sog": "SOG",
  "LogNavigationView_status": "Status",
  "LogNavigationView_status_anchor": "Vor Anker",
  "LogNavigationView_status_buoy": "An Boje",
  "LogNavigationView_status_drifting": "Treibend",
  "LogNavigationView_status_inmotion": "In Fahrt",
  "LogNavigationView_status_none": "Keine",
  "LogNavigationView_status_offboard": "Von Bord",
  "LogNavigationView_status_onboard": "An Bord",
  "LogNavigationView_status_port": "Im Hafen",
  "LogNavigationView_status_lock": "Schleuse",
  "LogNavigationView_status_bunkering": "Tankstelle",
  "LogNavigationView_status_bridge": "Brücke",
  "LogNavigationView_status_waiting": "Wartend",

  "LogNavigationView_stw": "STW",
  "LogNavigationView_time": "Zeit",
  "LogNavigationView_time_utc": "UTC",

  "LogNavigationView_created": "Log-Eintrag erstellt um",
  "LogNavigationView_updated": "Log-Eintrag aktualisiert um",
  "LogNavigationView_engine_rpms": "Motordrehzahl",
  "LogNavigationView_save_error_fields": "Nicht gespeichert — nicht erlaubt: {fields}",
  "LogNavigationView_save_error_generic": "Nicht gespeichert. Bitte erneut versuchen.",

  "LogWatchView": "",
  "LogWatchView_watch": "Wache",
  "LogWatchView_watch_comment": "Wach-Bemerkung",
  "LogWatchView_save_error_generic": "Nicht gespeichert. Bitte erneut versuchen.",

  "LogView": "",
  "LogView_details_created_by": "Erstellt von {name}",
  "LogView_details_updated_at": "Zuletzt aktualisiert am {date}",
  "LogView_details_last_edited_by": "Zuletzt bearbeitet von {name}",
  "LogView_details_last_edited": "Zuletzt bearbeitet",
  "LogView_label_auto": "auto",
  "LogView_label_default": "standard",
  "LogView_label_manual": "manuell",
  "LogView_label_nmea": "nmea",
  "LogView_log_alert": "Alarm {status}: {type} {info}",
  "LogView_log_alert_info_anchorDepth": "- {depth}",
  "LogView_log_alert_info_anchorDrift": "- {distance} vom Ankerpunkt abgetrieben",
  "LogView_log_alert_info_pressure": "- {action} um {delta} in {interval}",
  "LogView_log_alert_info_pressure_drop": "gesunken",
  "LogView_log_alert_info_pressure_raise": "gestiegen",
  "LogView_log_alert_anchorDrift": "Ankerdrift",
  "LogView_log_alert_depth": "Tiefe",
  "LogView_log_alert_lights": "Sichtzeichen",
  "LogView_log_alert_lostPosition": "Position verloren",
  "LogView_log_alert_manOverboard": "Mann über Bord",
  "LogView_log_alert_message": "Nachricht",
  "LogView_log_alert_pressure": "Luftdruck",
  "LogView_log_alert_test": "Test",
  "LogView_log_alert_wind": "Wind",
  "LogView_log_alert_start": "Alarm {alert} ist {status}",
  "LogView_log_alert_triggered": "Alarm {alert} ausgelöst",
  "LogView_log_alert_anchorDrift_detail": "{transition}: {problem}",
  "LogView_log_alert_depth_detail": "{transition}: {problem}",
  "LogView_log_alert_lostPosition_detail": "{transition}: {problem}",
  "LogView_log_alert_manOverboard_detail": "{transition}: {problem}",
  "LogView_log_alert_message_detail": "{transition}: {problem}",
  "LogView_log_alert_lostPosition_disconnected": "NMEA-Verbindung getrennt",
  "LogView_log_alert_lostPosition_stale": "Positionsdaten sind veraltet",
  "LogView_log_alert_lostPosition_jump": "unplausibler Positionssprung",
  "LogView_log_alert_lostPosition_invalidFix": "ungültiger GPS-Fix",
  "LogView_log_alert_manOverboard_emitterActivated": "MOB-Sender aktiviert",
  "LogView_log_alert_manOverboard_manualButtonActivated": "MOB-Taste aktiviert",
  "LogView_log_alert_manOverboard_manual": "manuell ausgelöst",
  "LogView_log_alert_manOverboard_unknown": "MOB-Signal empfangen",
  "LogView_log_alert_lights_detail": "{recorded} -> {recommended}: {transition}.",
  "LogView_log_alert_escalated": "Alarm {alert} eskaliert",
  "LogView_log_alert_escalated_by": "Alarm {alert} von {name} an den Skipper eskaliert",
  "LogView_log_alert_snoozed": "Alarm {alert} geschlummert",
  "LogView_log_alert_snoozed_by": "Alarm {alert} von {name} geschlummert",
  "LogView_log_alert_acknowledged": "Alarm {alert} bestätigt",
  "LogView_log_alert_acknowledged_by": "Alarm {alert} von {name} bestätigt",
  "LogView_log_alert_cleared": "Alarm {alert} gelöscht",
  "LogView_log_alert_cleared_by": "Alarm {alert} von {name} gelöscht",
  "LogView_log_alert_resolved": "Alarm {alert} beendet",
  "LogView_log_alert_status_acknowledged": "Bestätigt",
  "LogView_log_alert_status_alarm": "Alarm",
  "LogView_log_alert_status_ignored": "Ignoriert",
  "LogView_log_alert_status_ok": "OK",
  "LogView_log_alert_status_resolved": "Behoben",
  "LogView_log_alert_status_warning": "Warnung",
  "LogView_log_alert_type_anchorDepth": "Ankertiefe",
  "LogView_log_alert_type_anchorDrift": "Ankerdrift",
  "LogView_log_alert_type_pressure": "Luftdruck",
  "LogView_log_auto_interval": "Automatischer Eintrag nach {duration}",
  "LogView_log_change_add_crew": "Zur Crew hinzugefügt: {name}",
  "LogView_log_change_add_passengers": "Zu Passagieren hinzugefügt: {name}",
  "LogView_log_change_add_skipper": "Zu Skipper hinzugefügt: {name}",
  "LogView_log_change_remove_crew": "Aus Crew entfernt: {name}",
  "LogView_log_change_remove_passengers": "Aus Passagieren entfernt: {name}",
  "LogView_log_change_remove_skipper": "Aus Skipper entfernt: {name}",
  "LogView_log_course_change": "Kursänderung",
  "LogView_log_course_change_active": "Kursänderung um {angle} {side} in {duration} auf {course}",
  "LogView_log_course_change_end": "Kursänderung um {angle} {side} in {duration} von {course}",
  "LogView_log_course_change_side_port": "nach Backbord",
  "LogView_log_course_change_side_starboard": "nach Steuerbord",
  "LogView_log_course_change_started": "Kursänderung begonnen",
  "LogView_log_engine_start": "Motor gestartet",
  "LogView_log_engine_start_name": "Motor {name} gestartet",
  "LogView_log_engine_start_idle": "Motor im Leerlauf gestartet",
  "LogView_log_engine_start_idle_name": "Motor {name} im Leerlauf gestartet",
  "LogView_log_engine_stop": "Motor gestoppt",
  "LogView_log_engine_stop_name": "Motor {name} gestoppt",
  "LogView_log_engine_stop_duration": "Motor gestoppt nach {duration}",
  "LogView_log_engine_stop_duration_name": "Motor {name} gestoppt nach {duration}",
  "LogView_log_engine_stop_distance": "Motor gestoppt nach {duration} ({distance})",
  "LogView_log_engine_stop_distance_name": "Motor {name} gestoppt nach {duration} ({distance})",
  "LogView_log_engine_idle": "Motor im Leerlauf",
  "LogView_log_engine_idle_name": "Motor {name} im Leerlauf",
  "LogView_log_engine_load": "Motor unter Last",
  "LogView_log_engine_load_name": "Motor {name} unter Last",
  "LogView_log_engine_load_duration": "Motor unter Last nach {duration}",
  "LogView_log_engine_load_duration_name": "Motor {name} unter Last nach {duration}",
  "LogView_log_engine_missing": "Motorinformationen fehlen, vermutlich gestoppt",
  "LogView_log_engine_missing_name": "Motor {name} Informationen fehlen, vermutlich gestoppt",
  "LogView_log_engine_missing_duration": "Motorinformationen fehlen, vermutlich gestoppt nach {duration}",
  "LogView_log_engine_missing_duration_name": "Motor {name} Informationen fehlen, vermutlich gestoppt nach {duration}",
  "LogView_log_engine_missing_distance": "Motorinformationen fehlen, vermutlich gestoppt nach {duration} ({distance})",
  "LogView_log_engine_missing_distance_name": "Motor {name} Informationen fehlen, vermutlich gestoppt nach {duration} ({distance})",
  "LogView_log_propulsion_off": "Unter Segeln, kein Motor in Betrieb",
  "LogView_log_propulsion_off_noSails": "Kein Motor in Betrieb",
  "LogView_log_engine_missing_hint_castOff": "Fehlt ein Motoreintrag seit dem Ablegen?",
  "LogView_log_engine_missing_hint_anchorUp": "Fehlt ein Motoreintrag seit dem Ankerlichten?",
  "LogView_log_engine_missing_hint_motorVessel": "Fehlt ein Motoreintrag seit der Abfahrt?",
  "LogView_log_generator_start": "Generator {number} gestartet",
  "LogView_log_generator_stop": "Generator {number} gestoppt",
  "LogView_log_lighting": "Sichtzeichen auf {lighting} gesetzt",
  "LogView_log_lighting_none": "Keine Sichtzeichen geführt",
  "LogView_log_monitor_start": "Monitor {monitor} gestartet",
  "LogView_log_monitor_stop": "Monitor {monitor} gestoppt",
  "LogView_log_monitor_anchor": "Anker-Alarm",
  "LogView_log_monitor_depth": "Tiefenwache",
  "LogView_log_navigation_status_start": "Navigation gestartet",
  "LogView_log_navigation_status_stop": "Navigation gestoppt",
  "LogView_log_nmea_connection_resume": "NMEA-Verbindung für Navigationsdaten wiederhergestellt",
  "LogView_log_nmea_connection_stop": "NMEA-Verbindung für Navigationsdaten verloren",
  "LogView_log_nmea_connection_start": "NMEA-Verbindung gestartet für",
  "LogView_log_nmea_connection_user_stop": "NMEA-Verbindung für Navigationsdaten geschlossen",
  "LogView_log_pause_start": "Beginn der Pause",
  "LogView_log_pause_stop": "Ende der Pause",
  "LogView_log_pause_stop_duration": "Ende der Pause nach {duration}",
  "LogView_log_pause_stop_status": "{status} beendet",
  "LogView_log_pause_stop_status_duration": "{status} beendet nach {duration}",
  "LogView_log_status_anchor": "Vor Anker",
  "LogView_log_status_bunkering": "An der Tankstelle",
  "LogView_log_status_buoy": "An Boje",
  "LogView_log_status_drifting": "Treibend",
  "LogView_log_status_inmotion": "In Fahrt",
  "LogView_log_status_offboard": "Von Bord",
  "LogView_log_status_onboard": "An Bord",
  "LogView_log_status_port": "Im Hafen",
  "LogView_log_status_lock": "In Schleuse",
  "LogView_log_status_bridge": "An der Brücke",
  "LogView_log_status_waiting": "Wartend",
  "LogView_log_status_location": "{status}: {location}",
  "LogView_log_stop": "Angehalten für {stop}",
  "LogView_log_stop_location": "Angehalten für {stop} bei {location}",
  "LogView_log_stop_type_endOfDay": "Tagesende",
  "LogView_log_stop_type_stopover": "Zwischenstopp",
  "LogView_log_sail_down": "{sail} geborgen",
  "LogView_log_sail_up": "{sail} gesetzt",

  "LogView_nmea_auto_course_change_entries": "Kursänderungseinträge",
  "LogView_nmea_auto_entries": "Auto-Einträge",
  "LogView_nmea_pending": "Log",
  "LogView_provisional_cancel_discard": "Eintrag verwerfen",
  "LogView_provisional_cancel_error": "Der Eintrag konnte nicht verworfen werden. Bitte erneut versuchen.",
  "LogView_provisional_cancel_keep": "Behalten",
  "LogView_provisional_cancel_message_courseChange": "Diese Kursänderung verwerfen? Für dieses Manöver wird kein Eintrag aufgezeichnet.",
  "LogView_provisional_cancel_message_speedChange": "Diese Pause verwerfen? Es wird kein Eintrag aufgezeichnet und das Schiff bleibt in Fahrt.",
  "LogView_provisional_cancel_title_courseChange": "Kursänderung verwerfen",
  "LogView_provisional_cancel_title_speedChange": "Pause verwerfen",
  "LogView_tab_environment": "Umgebung",
  "LogView_tab_navigation": "Navigation",
  "LogView_tab_watch": "Wache",

  "LoginView": "",
  "LoginView_error_confirmation_failed": "E-Mail-Bestätigung fehlgeschlagen. Wenn das Konto zuvor aktiviert wurde, kannst du die Funktion 'Passwort vergessen' unten verwenden.",
  "LoginView_error_failed": "Login fehlgeschlagen. Bitte überprüfe deine E-Mail und dein Passwort und versuche es erneut.",
  "LoginView_error_failed_request": "Login fehlgeschlagen. Bitte überprüfe deine Internet-Verbindung und versuche es erneut.",
  "LoginView_error_native_login_failed": "Die Anmeldung konnte nicht abgeschlossen werden. Bitte kehre zur App zurück und versuche es erneut.",
  "LoginView_local_login_required": "Öffne LOGBOOK auf diesem Gerät, um dich anzumelden. Die Primary-Anmeldung ist nur in der lokalen App dieses Geräts möglich.",
  "LoginView_companion_handoff_failed": "Die Companion-Verbindung konnte nicht hergestellt werden. Öffne LOGBOOK auf diesem Gerät und verbinde dich erneut über deine Schiffsliste.",
  "LoginView_companion_handoff_pending": "Verbindung zum Primary LOGBOOK wird hergestellt...",
  "LoginView_error_native_login_invalid": "Die Anmeldung kann nicht fortgesetzt werden, weil der App-Rückruf fehlt oder ungültig ist.",
  "LoginView_error_signup_failed": "Registrierung fehlgeschlagen.",
  "LoginView_error_signupEmailAlreadyExists": "Registrierung fehlgeschlagen. E-Mail-Adresse wird bereits verwendet.",
  "LoginView_error_signupAccountAlreadyExists": "Registrierung fehlgeschlagen. Ein Account mit diesem Namen existiert bereits.",
  "LoginView_error_signupNameInvalid": "Bitte gib deinen Namen ein (mindestens 3 Zeichen).",
  "LoginView_error_signupEmailInvalid": "Bitte gib eine gültige E-Mail-Adresse ein.",
  "LoginView_error_signupPasswordInvalid": "Das Passwort muss mindestens 3 Zeichen lang sein.",
  "LoginView_error_invitation_accept_failed": "Annahme der Einladung fehlgeschlagen. Bitte stelle sicher, dass du mit dem Account angemeldet bist, an den die Einladung gesendet wurde, und versuche es erneut.",
  "LoginView_forgot_password": "Passwort vergessen",
  "LoginView_forgot_password_complete": "Passwort geändert. Du kannst dich nun mit dem neuen Passwort anmelden.",
  "LoginView_forgot_password_email": "Bitte gib die E-Mail-Adresse deines Kontos ein, um die Wiederherstellung des Passworts zu starten.",
  "LoginView_forgot_password_email_sent": "Wenn ein Konto für diese E-Mail-Adresse existiert, erhältst du eine E-Mail mit den nächsten Schritten.",
  "LoginView_forgot_password_new_password": "Bitte gib ein neues Passwort ein, um die Wiederherstellung des Passworts abzuschließen.",
  "LoginView_error_reset_failed": "Wiederherstellung des Passworts fehlgeschlagen. Bitte versuche es erneut.",
  "LoginView_error_reset_failed_request": "Wiederherstellung des Passworts fehlgeschlagen. Bitte überprüfe deine Internetverbindung und versuche es erneut.",
  "LoginView_form_back_to_login": "Zurück zum Login",
  "LoginView_form_name": "Name",
  "LoginView_form_email": "E-Mail",
  "LoginView_form_new_password": "Neues Passwort",
  "LoginView_form_new_password_confirmation": "Neue Passwortbestätigung",
  "LoginView_form_password": "Passwort",
  "LoginView_form_submit": "Login",
  "LoginView_form_submit_forgot_password": "Zurücksetzen",
  "LoginView_form_submit_forgot_password_loading": "Zurücksetzen…",
  "LoginView_form_submit_login": "Login",
  "LoginView_form_submit_login_loading": "Login…",
  "LoginView_form_submit_signup": "Registrieren",
  "LoginView_form_forgot_password": "Passwort\u00A0vergessen?",
  "LoginView_form_account_name": "Account-Name",

  "LoginView_reset_app_title": "App zurücksetzen",
  "LoginView_reset_app_cancel": "Abbrechen",
  "LoginView_reset_app_action": "Zurücksetzen starten",

  "LoginView_welcome": "Willkommen bei LOGBOOK.",
  "LoginView_signup_link_unavailable": "Der Link zur Registrierung konnte nicht geladen werden. Bitte versuche es erneut.",
  "LoginView_signup_link_retry": "Erneut versuchen",
  "LoginView_login": "Du hast bereits einen Account? Melde dich einfach bei LOGBOOK an.",
  "LoginView_login_email": "Melde dich mit deiner E-Mail und dem Passwort an.",
  "LoginView_native_sign_in_loading": "Anmeldung läuft…",
  "LoginView_native_sign_in_fallback": "Mit Safari anmelden",
  "LoginView_native_sign_in_or": "oder",
  "LoginView_signup": "Du bist neu bei LOGBOOK? Registriere dich einfach für LOGBOOK.",
  "LoginView_signup_email": "Registriere dich mit deiner E-Mail und einem Passwort.",
  "LoginView_invitation_use_other_account": "Anderen Account verwenden",
  "LoginView_invitation_accept": "Einladung annehmen",
  "LoginView_footer_about": "Über uns",
  "LoginView_footer_help": "Hilfe",
  "LoginView_footer_language": "Sprache",
  "LoginView_footer_reset_app": "App zurücksetzen",

  "Menu": "",
  "Menu_ship": "Schiff",
  "Menu_account": "Account",

  "MenuAccount": "",
  "MenuAccount_account_settings": "Account-Einstellungen",
  "MenuAccount_remove_account": "Account löschen",
  "MenuAccount_close_companion": "Companion trennen",
  "MenuAccount_open_cloud": "Zur LOGBOOK-Cloud",
  "MenuAccount_account_settings_app": "Zur LOGBOOK-App",
  "MenuAccount_logout": "Abmelden",
  "MenuAccount_switch_user": "User wechseln",
  "MenuAccount_return_to_own_user": "Zurück zu {name}",
  "MenuAccount_user_settings": "User-Einstellungen",

  "MenuHelp": "",
  "MenuHelp_about": "Über\u00A0LOGBOOK",
  "MenuHelp_change_log": "Änderungsprotokoll",
  "MenuHelp_contact_support": "Support\u00A0kontaktieren",
  "MenuHelp_documentation": "Dokumentation",
  "MenuHelp_help": "Hilfe",
  "MenuHelp_support": "Support-Seite",
  "MenuHelp_qanda": "Tipps",
  "MenuHelp_demo": "Interaktive Demos",
  "MenuHelp_title": "Hilfe",

  "MenuAlerts": "",
  "MenuAlerts_title": "Alarme",

  "MenuNMEA": "",
  "MenuNMEA_connection": "NMEA-Verbindung",
  "MenuNMEA_last_update": "Letzte Aktualisierung: {timestamp}",
  "MenuNMEA_recording": "Automatisches Loggen",
  "MenuNMEA_settings": "Einstellungen",
  "MenuNMEA_title": "NMEA",

  "MenuShip": "",
  "MenuShip_close": "LOGBOOK {name} schließen",
  "MenuShip_logout": "Von \"{name}\" abmelden",
  "MenuShip_data_name": "{name} Schiffsdaten",
  "MenuShip_new": "Neues Schiff",
  "MenuShip_settings_name": "{name} Einstellungen",
  "MenuShip_select": "Schiff auswählen",
  "MenuShip_view_cloud": "\"{name}\" in Cloud anzeigen",
  "MenuShip_view_ships": "Schiffsliste anzeigen",

  "MenuSync": "",
  "MenuSync_internet_status": "Internet-Verbindung",
  "MenuSync_last_update": "Letzte Aktualisierung: {timestamp}",
  "MenuSync_status": "Sync-Status",
  "MenuSync_title": "Sync",
  "MenuSync_resync": "Verbindung wiederherstellen",
  "MenuSync_relogin": "Erneut einloggen",

  "NMEAConfigurationView": "",
  "NMEAConfigurationView_blank": "\u00A0",
  "NMEAConfigurationView_and": "und",
  "NMEAConfigurationView_banner_start_setup": "NMEA-Einrichtung starten",
  "NMEAConfigurationView_banner_text": "NMEA-Verbindung ist nicht aktiviert.",
  "NMEAConfigurationView_cancel": "Abbrechen",
  "NMEAConfigurationView_checks": "Verfügbare NMEA-Daten:",
  "NMEAConfigurationView_check_air_pressure": "Luftdruck",
  "NMEAConfigurationView_check_air_humidity": "Luftfeuchtigkeit",
  "NMEAConfigurationView_check_air_temperature": "Lufttemperatur",
  "NMEAConfigurationView_check_depth": "Tiefe",
  "NMEAConfigurationView_check_engine": "Motor-Drehzahl",
  "NMEAConfigurationView_check_engine_1": "Motor-Drehzahl #1",
  "NMEAConfigurationView_check_engine_2": "Motor-Drehzahl #2",
  "NMEAConfigurationView_check_engine_3": "Motor-Drehzahl #3",
  "NMEAConfigurationView_check_engine_4": "Motor-Drehzahl #4",
  "NMEAConfigurationView_check_engine_5": "Motor-Drehzahl #5",
  "NMEAConfigurationView_check_engine_ids": "Empfangene Motor IDs: {ids}",
  "NMEAConfigurationView_check_engine_ids_none": "keine",
  "NMEAConfigurationView_check_navigation_course": "Heading",
  "NMEAConfigurationView_check_navigation_gps": "GPS-Position",
  "NMEAConfigurationView_check_navigation_log": "Distanz durchs Wasser",
  "NMEAConfigurationView_check_navigation_sog": "Geschwindigkeit über Grund",
  "NMEAConfigurationView_check_utc": "UTC",
  "NMEAConfigurationView_check_water_temperature": "Wassertemperatur",
  "NMEAConfigurationView_check_native_gps": "Interne GPS-Position",
  "NMEAConfigurationView_check_native_air_pressure": "Interner Luftdruck",
  "NMEAConfigurationView_check_wind": "Wind (Geschwind. und Richtung)",
  "NMEAConfigurationView_connection_device": "Gerät",
  "NMEAConfigurationView_connection_host": "Adresse",
  "NMEAConfigurationView_connection_port": "Port",
  "NMEAConfigurationView_connection_type": "NMEA-Verbindungstyp",
  "NMEAConfigurationView_connection_type_bluetooth": "Bluetooth (nicht unterstützt)",
  "NMEAConfigurationView_connection_type_gps": "Internes GPS",
  "NMEAConfigurationView_connection_type_tcp": "TCP",
  "NMEAConfigurationView_connection_type_udp": "UDP",
  "NMEAConfigurationView_connection_type_usb": "USB",
  "NMEAConfigurationView_connect": "Verbindung testen",
  "NMEAConfigurationView_connecting": "Verbinde...",
  "NMEAConfigurationView_capture": "NMEA-Daten an Support senden",
  "NMEAConfigurationView_capture_sending": "Wird gesendet...",
  "NMEAConfigurationView_capture_success": "Gesendet",
  "NMEAConfigurationView_capture_error": "Senden fehlgeschlagen",
  "NMEAConfigurationView_capture_hint": "Sendet eine kurze Aufzeichnung der Rohdaten deiner Instrumente, damit der Support Verbindungsprobleme analysieren kann.",
  "NMEAConfigurationView_complete": "Abschließen",
  "NMEAConfigurationView_error_invalidUrl": "Fehler: Ungültige URL",
  "NMEAConfigurationView_error_connectionFailed": "Fehler: Verbindung fehlgeschlagen",
  "NMEAConfigurationView_error_disconnected": "Fehler: NMEA ist nicht verbunden",
  "NMEAConfigurationView_error_failedToOpen": "Fehler: Gerät konnte nicht geöffnet werden",
  "NMEAConfigurationView_error_subscriptionExpired": "Fehler: Abonnement abgelaufen",
  "NMEAConfigurationView_error_unsupportedSchema": "Fehler: Nicht unterstütztes Protokoll",
  "NMEAConfigurationView_reconnect": "Neu verbinden",
  "NMEAConfigurationView_reset": "Zurücksetzen",
  "NMEAConfigurationView_step_conditions": "Bedingungen",
  "NMEAConfigurationView_step_connection": "Verbindung",
  "NMEAConfigurationView_step_native": "Interne Sensoren",
  "NMEAConfigurationView_step_test_data": "Test und Daten",
  "NMEAConfigurationView_title": "NMEA-Einstellungen",
  "NMEAConfigurationView_read_more": "Mehr lesen",
  "NMEAConfigurationView_condition_entry": "Bedingungen für automatische Logbucheinträge",
  "NMEAConfigurationView_condition_interval": "Regelmäßige Einträge alle ",
  "NMEAConfigurationView_condition_interval_3600": "60 min ",
  "NMEAConfigurationView_condition_interval_1800": "30 min ",

  "NMEAConfigurationView_condition_start_stop": "Bedingung für Start/Stopp-Eintrag",
  "NMEAConfigurationView_condition_anchor_start_stop": "Anderer Wert für Anker oder Boje",
  "NMEAConfigurationView_condition_anchor_no_status_change": "Keine Statusänderung, wenn Geschwindigkeit",
  "NMEAConfigurationView_condition_anchor_depth_alerts": "Anker- & Tiefenalarme",
  "NMEAConfigurationView_condition_anchor_drift_warning": "Ankerdrift-Warnung (sm)",
  "NMEAConfigurationView_condition_anchor_drift_alarm": "Ankerdrift-Alarm (sm)",
  "NMEAConfigurationView_condition_depth_warning": "Tiefenwarnung",
  "NMEAConfigurationView_condition_depth_alarm": "Tiefenalarm",
  "NMEAConfigurationView_condition_stop": "Stopp-Eintrag wenn Geschwindigkeit",
  "NMEAConfigurationView_condition_start": "Start-Eintrag wenn Geschwindigkeit ",
  "NMEAConfigurationView_condition_course": "Eintrag bei Kursänderung wenn ",
  "NMEAConfigurationView_condition_course_change": "Kursänderung",
  "NMEAConfigurationView_condition_course_speed": "Geschwindigkeit",
  "NMEAConfigurationView_condition_native_gps": "Internes GPS verwenden",
  "NMEAConfigurationView_condition_native_pressure": "Internen Luftdrucksensor verwenden",
  "NMEAConfigurationView_condition_engine_idle_rpm": "Wenn der Motor mit weniger als der Leerlaufdrehzahl (U/min) läuft: Zeit und Entfernung als \"unter Segeln\" auswerten.",
  "NMEAConfigurationView_condition_engine_idle_rpm_value": "Leerlaufdrehzahl (U/min)",
  "NMEAConfigurationView_condition_engine_detection": "Motorerkennung (U/min)",
  "NMEAConfigurationView_condition_engine_start": "Motor läuft, wenn Drehzahl über",
  "NMEAConfigurationView_condition_engine_stop": "Motor aus, wenn Drehzahl unter",
  "NMEAConfigurationView_error_engine_rpm_order": "Fehler: Drehzahl \"Motor aus\" muss unter \"Motor läuft\" liegen",
  "NMEAConfigurationView_error_engine_idle_rpm": "Fehler: Leerlaufdrehzahl muss über \"Motor läuft\" liegen",
  
  "NoteView": "",
  "NoteView_planning": "Törnplan",
  "NoteView_crew": "Crew",
  "NoteView_day": "Tag",
  "NoteView_file_field_drag_drop": "Dateien an diese Notiz anhängen.",
  "NoteView_attachment_remove_confirm": "Möchtest du diesen Anhang wirklich entfernen?",
  "NoteView_attachment_remove_title": "Anhang entfernen",
  "NoteView_attachment_remove_accept": "Entfernen",
  "NoteView_attachment_remove_cancel": "Abbrechen",
  "NoteView_attachment_remove_error": "Anhang konnte nicht entfernt werden. Bitte versuche es erneut.",
  "NoteView_journal": "Journal",
  "NoteView_note_created_by": "Erstellt von {name}",
  "NoteView_note_parent_day": "Tag: {date}",
  "NoteView_note_parent_trip": "Etappe: {name}",
  "NoteView_other": "Andere",
  "NoteView_technical": "Technisch",
  "NoteView_type": "Typ",
  "NoteView_weather": "Wettervorhersage",
  "NoteView_show_notes": "{count} {type}-Notizen anzeigen",
  "NoteView_watch": "Wachplan",

  "NoteView_note_add_new": "Neue Notiz hinzufügen",

  "NoteView_note_journal_title": "Journal-Eintragstitel",
  "NoteView_note_journal_note": "Journal-Text",

  "NoteView_note_planning_date": "Datum",
  "NoteView_note_planning_title": "Ort",
  "NoteView_note_planning_note": "Bemerkung",

  "NoteView_note_technical_title": "Technischer Notiztitel",
  "NoteView_note_technical_note": "Technische Notiz",

  "NoteView_note_parent_type_day": "Tag",
  "NoteView_note_parent_type_trip": "Etappe",

  "NoteView_note_weather_title": "Quelle",
  "NoteView_note_weather_date": "Datum und Zeit",
  "NoteView_note_weather_note": "Wettervorhersage",
  "NoteView_note_weather_note_extra": "Wetterbedingungen",

  "PrintHeaderView": "",
  "PrintHeaderView_title": "LOGBOOK {view} – {ship}",
  "PrintHeaderView_print_1": "Törnübersicht",
  "PrintHeaderView_print_2": "Ausgewählte Etappen",
  "PrintHeaderView_print_3": "Ausgewählte Tage",
  "PrintHeaderView_print_4": "Schiffsdaten",
  "PrintHeaderView_motor": "Motorschiff",
  "PrintHeaderView_sailing": "Segelschiff",

  "PrintSettingsView": "",
  "PrintSettingsView_title": "Druckeinstellungen",
  "PrintSettingsView_button": "Drucken",
  "PrintSettingsView_cancel": "Abbrechen",
  "PrintSettingsView_overview": "Übersicht drucken",
  "PrintSettingsView_overview_all": "Alle Törns in LOGBOOK drucken",
  "PrintSettingsView_overview_year": "Jahr auswählen",
  "PrintSettingsView_overview_cruises": "Übersicht der Törns drucken",

  "PrintSettingsView_cruise": "Törn drucken",
  "PrintSettingsView_cruise_current": "Alle Daten des Törns gefolgt von einer Liste aller Etappen drucken",
  "PrintSettingsView_cruise_summary": "Törndaten und Liste der Etappen",
  "PrintSettingsView_cruise_details": "Törndetails",

  "PrintSettingsView_ship": "Schiffsdaten drucken",
  "PrintSettingsView_ship_short": "Hauptschiffsdaten",
  "PrintSettingsView_ship_details": "Detaillierte Schiffsdaten",
  "PrintSettingsView_user_list": "Alle Personen für dieses Schiff drucken",

  "PrintSettingsView_trip": "Etappen",
  "PrintSettingsView_trips": "Etappen drucken",
  "PrintSettingsView_trips_all": "Alle Etappen des Törns drucken",
  "PrintSettingsView_trips_selected": "Etappe zum Drucken auswählen",
  "PrintSettingsView_timeline": "Timeline",
  "PrintSettingsView_trips_summary": "Alle Daten der Etappen drucken und",
  "PrintSettingsView_trips_summary_details": "eine Liste der Tage mit Details",
  "PrintSettingsView_trips_summary_short": "eine kurze Liste der Tage",
  "PrintSettingsView_trips_details": "Etappen-Details",
  "PrintSettingsView_journal_list": "Alle Journal-Einträge drucken (Etappen und Tage)",
  "PrintSettingsView_technical_list": "Alle technischen Einträge drucken (Etappen und Tage)",

  "PrintSettingsView_days": "Tage drucken",
  "PrintSettingsView_days_select": "Einzelnen Tag auswählen",
  "PrintSettingsView_days_trip_select": "Alle Tage der ausgewählten Etappe drucken",
  "PrintSettingsView_days_text": "Daten des Tages drucken: Reiter Tag und Statistik plus die unten gewählten Reiter:",
  "PrintSettingsView_thumbnails": " (inkl. Bild-Miniaturansichten)",

  "PrintSettingsView_entries": "Log-Einträge auch an jeden Tag anhängen",
  "PrintSettingsView_edits": "Alle Änderungen an Log-Einträgen und auf der Karte Tag ausgeben",
  "PrintSettingsView_entries_summary": "Zusammenfassung (Liste der Log-Einträge)",
  "PrintSettingsView_entries_details": "Detaillierte Log-Einträge",
  "PrintSettingsView_entries_day_select": "Tag auswählen",
  "PrintSettingsView_entries_trip_select": "Etappe zum Drucken von Tagen auswählen",

  "PrintSettingsView_evaluations": "Auswertungen drucken",
  "PrintSettingsView_journal": "Journal-Einträge mit Fotos",
  "PrintSettingsView_tacks": "Tracks",
  "PrintSettingsView_technical": "Technische Dokumentation mit Fotos",

  "PrintSettingsView_authorities": "Auswertung für Behörden",
  "PrintSettingsView_authorities_day": "Manuelle Einträge für den Tag",
  "PrintSettingsView_authorities_log": "Log-Einträge",

  "PrintView": "",
  "PrintView_print_action": "Drucken",
  "PrintView_print_cancel": "Abbrechen",
  "PrintView_cruise": "Törn",
  "PrintView_cruise_statistics": "Statistik des Törns",
  "PrintView_trip": "Etappe",
  "PrintView_trips": "Etappen",

  "PrintView_trip_list": "Liste der Etappen",
  "PrintView_trip_statistics": "Statistik der Etappe",
  "PrintView_day": "Logbuchdaten für",
  "PrintView_day_list": "Liste der Tage in der Etappe",
  "PrintView_day_maindata": "Hauptdaten des Tages",
  "PrintView_day_statistics": "Statistik des Tages",
  "PrintView_date": "Datum",
  "PrintView_from_date": "Von",
  "PrintView_until_date": "bis",
  "PrintView_from_loc": "Törn von",
  "PrintView_to_loc": "nach",
  "PrintView_time_total": "Zeit",
  "PrintView_distance_total": "Distanz",
  "PrintView_technical_notes": "Technische Notizen",

  "PrintView_watch_groups": "Wachgruppen",
  "PrintView_watch_shifts": "Wachschichten",

  "PrintView_note_technical": "Technische Notiz",
  "PrintView_list_technical": "Liste aller technischen Notizen",
  "PrintView_note_journal": "Journal-Eintrag",
  "PrintView_list_journal": "Liste aller Journal-Einträge",

  "PrintView_note_watch": "Wache",
  "PrintView_note_planning": "Törnplan",
  "PrintView_note_weather": "Wettervorhersage",

  "PrintView_log_entries": "Log-Einträge",

  "SearchView": "",
  "SearchView_token_ship": "Schiff",
  "SearchView_token_type": "Typ",
  "SearchView_type_cruise": "Törn",
  "SearchView_type_day": "Tag",
  "SearchView_type_log": "Log",
  "SearchView_type_note": "Notiz",
  "SearchView_type_trip": "Etappe",

  "ShipImportView": "",
  "ShipImportView_cancel": "Abbrechen",
  "ShipImportView_file_field_drag_drop": "Wähle die Exportdatei aus LogbookSuite aus",
  "ShipImportView_open": "Schiff anzeigen",
  "ShipImportView_status_complete": "Abgeschlossen",
  "ShipImportView_status_failed": "Fehlgeschlagen. Bitte versuche es erneut oder kontaktiere den Support.",
  "ShipImportView_status_error": "Fehler: {error}",
  "ShipImportView_status_processing": "In Bearbeitung",
  "ShipImportView_status_pending": "Vorbereitung zum Import",
  "ShipImportView_status_uploading": "Hochladen",
  "ShipImportView_title": "Schiffsdaten importieren",
  "ShipImportView_title_ship": "Etappen in {ship} importieren",

  "ShipSettingsView_settings": "Einstellungen",
  "ShipSettingsView_ship_settings": "Schiffseinstellungen",
  "ShipSettingsView_tab_units": "Einstellungen für Einheiten",
  "ShipSettingsView_tab_ship_user": "Alle Personen",
  "ShipSettingsView_tab_lists": "Einstellungen für Listen",
  "ShipSettingsView_tab_settings": "Einstellungen",
  "ShipSettingsView_tab_companions": "Companions",
  "ShipSettingsView_more_info": "Mehr erfahren", 
  "ShipSettingsView_read_more": "Weiterlesen", 
  "ShipSettingsView_add_user": "Person",
  "ShipSettingsView_cancel": "Abbrechen",
  "ShipSettingsView_save": "Hinzufügen",
  "ShipSettingsView_timezone": "Zeitzone",
  "ShipSettingsView_timezone_title": "Manuelle Einrichtung der Zeitzone",
  "ShipSettingsView_timezone_manual": "Zeitzone manuell einstellen",
  "ShipSettingsView_current_time": "Aktuelle Zeit",
  "ShipSettingsView_log_offset_title": "Offset für Wert aus der Logge",
  "ShipSettingsView_log_offset": "Log-Offset (nm)",
  "ShipSettingsView_rpm_title": "Manuell eingegebene Drehzahl übernehmen",
  "ShipSettingsView_rpm_keep_manual": "Drehzahl in den nächsten Logeintrag übernehmen",
  "ShipSettingsView_lights_title": "Erinnerung an die Sichtzeichen",
  "ShipSettingsView_lights_enable": "An die Sichtzeichen erinnern",
  "ShipSettingsView_lights_sailing": "Lichter unter Segeln",
  "ShipSettingsView_lights_sailing_runningLights": "Getrennte Positionslichter",
  "ShipSettingsView_lights_sailing_triColor": "Dreifarbenlaterne im Masttop",
  "ShipSettingsView_lights_lead": "Tag-/Nachtgrenze",
  "ShipSettingsView_lights_lead_civil": "Bürgerliche Dämmerung (empfohlen)",
  "ShipSettingsView_lights_lead_official": "Sonnenuntergang / Sonnenaufgang",
  "ShipSettingsView_lights_motoring_cone": "An das Setzen des Motorkegels erinnern",
  "ShipSettingsView_edit_permissiveness_title": "Bearbeitungsfreigabe",
  "ShipSettingsView_edit_permissiveness_level": "Bearbeitungsstufe",
  "ShipSettingsView_edit_permissiveness_level_default": "Standard (streng)",
  "ShipSettingsView_edit_permissiveness_level_extended": "Erweitert",
  "ShipSettingsView_edit_permissiveness_level_unrestricted": "Uneingeschränkt",
  "ShipSettingsView_socket": "Adresse des Primary LOGBOOK",
  "ShipSettingsView_socket_text": "Verwende diese Adresse für die Verbindung eines Companions mit dem Primary LOGBOOK",
  "ShipSettingsView_connected_companions": "Verbundene Companions",
  "ShipSettingsView_companion_host": "Host",
  "ShipSettingsView_companion_user": "Benutzer",
  "ShipSettingsView_companions_loading": "Verbundene Companions werden geladen…",
  "ShipSettingsView_companions_empty": "Derzeit sind keine Companions verbunden.",
  "ShipSettingsView_companions_error": "Verbundene Companions konnten nicht geladen werden. Erneuter Versuch…",
  "ShipSettingsView_disconnect_companion": "Trennen",
  "ShipSettingsView_disconnect_companion_label": "{user} auf {host} trennen",
  "ShipSettingsView_disconnect_companion_title": "Companion trennen?",
  "ShipSettingsView_disconnect_companion_text": "Dieser Companion muss anschließend manuell erneut verbunden werden. Die Schiffsberechtigungen des Benutzers und andere Geräte bleiben unverändert.",
  "ShipSettingsView_disconnect_companion_error": "Dieser Companion konnte nicht getrennt werden. Bitte erneut versuchen.",

  "ShipSettingsView_units": "Einstellungen für Einheiten",

  "ShipSettingsView_comment_": "*Wählen/eingeben*",
  "ShipSettingsView_seaState_": "*Wählen/eingeben*",

  "ShipSettingsView_comment_anchor_down": "Anker fällt",
  "ShipSettingsView_comment_anchor_up": "Anker auf",
  "ShipSettingsView_comment_engine_started": "Motor gestartet",
  "ShipSettingsView_comment_engine_stopped": "Motor gestoppt",
  "ShipSettingsView_comment_sails_set": "Segel gesetzt",
  "ShipSettingsView_comment_sails_dropped": "Segel geborgen",

  "ShipSettingsView_add_seaState": "Seegang hinzufügen",
  "ShipSettingsView_add_comment": "Bemerkung hinzufügen",

  "ShipSettingsView_seaState_waves": "Wellen",
  "ShipSettingsView_seaState_swell": "Dünung",
  "ShipSettingsView_seaState_cross_sea": "Kreuzsee",
  "ShipSettingsView_seaState_calm": "Ruhige See",
  "ShipSettingsView_seaState_rough": "Raue See",

  "ShipSettingsView_currency": "Währung",
  "ShipSettingsView_distance": "Distanz",
  "ShipSettingsView_length": "Länge",
  "ShipSettingsView_power": "Leistung",
  "ShipSettingsView_pressure": "Druck",
  "ShipSettingsView_speed": "Geschwindigkeit",
  "ShipSettingsView_surface": "Fläche",
  "ShipSettingsView_temperature": "Temperatur",
  "ShipSettingsView_volume": "Volumen",
  "ShipSettingsView_weight": "Gewicht",
  "ShipSettingsView_wind": "Wind",
  "ShipSettingsView_current": "Strömung",
  "ShipSettingsView_unit_currency": "Währung",

  "ShipSettingsView_unit_bar": "bar",
  "ShipSettingsView_unit_celsius": "°C",
  "ShipSettingsView_unit_cm": "cm",
  "ShipSettingsView_unit_fahrenheit": "°F",
  "ShipSettingsView_unit_foot": "Fuß",
  "ShipSettingsView_unit_gal": "gal",
  "ShipSettingsView_unit_inch": "Zoll",
  "ShipSettingsView_unit_kg": "kg",
  "ShipSettingsView_unit_km": "km",
  "ShipSettingsView_unit_kmh": "km/h",
  "ShipSettingsView_unit_kn": "kn",
  "ShipSettingsView_unit_kw": "kw",
  "ShipSettingsView_unit_kwh": "kwh",
  "ShipSettingsView_unit_hp": "PS",
  "ShipSettingsView_unit_l": "l",
  "ShipSettingsView_unit_m3": "m³",
  "ShipSettingsView_unit_cuft": "cuft",
  "ShipSettingsView_unit_mps": "m/s",
  "ShipSettingsView_unit_m": "m",
  "ShipSettingsView_unit_m2": "m²",
  "ShipSettingsView_unit_miles": "Meilen",
  "ShipSettingsView_unit_mph": "mph",
  "ShipSettingsView_unit_nm": "sm",
  "ShipSettingsView_unit_lb": "lb",
  "ShipSettingsView_unit_ft": "ft",
  "ShipSettingsView_unit_in": "in",
  "ShipSettingsView_unit_sqft": "sqft",
  "ShipSettingsView_unit_psi": "psi",
  "ShipSettingsView_unit_sqyd": "sqyd",
  "ShipSettingsView_unit_tons": "to",
  "ShipSettingsView_unit_yard": "Yard",
  "ShipSettingsView_unit_hpa": "hPa",

  "ShipSettingsView_unit_undefined": "*Wählen/eingeben*",
  "ShipSettingsView_other": "Anderes eingeben",

  "ShipSettingsView_unit_eur": "€",
  "ShipSettingsView_unit_usd": "$",
  "ShipSettingsView_unit_gbp": "£",
  "ShipSettingsView_unit_aud": "AU$",
  "ShipSettingsView_unit_nzd": "NZ$",
  "ShipSettingsView_unit_chf": "CHF",
  "ShipSettingsView_unit_sek": "SEK",
  "ShipSettingsView_unit_nok": "NOK",
  "ShipSettingsView_unit_dkk": "DKK",
  "ShipSettingsView_unit_jpy": "¥",

  "ShipSettingsView_user_crew_role": "Crew-Rolle",
  "ShipSettingsView_ship_user_crew_role_crew": "Crew",
  "ShipSettingsView_ship_user_crew_role_none": "Keine",
  "ShipSettingsView_ship_user_crew_role_owner": "Account-Inhaber",
  "ShipSettingsView_ship_user_crew_role_skipper": "Skipper",
  "ShipSettingsView_user_email": "E-Mail",
  "ShipSettingsView_language": "Sprache",
  "ShipSettingsView_lang_en": "Englisch",
  "ShipSettingsView_lang_de": "Deutsch",
  "ShipSettingsView_lang_fr": "Französisch",
  "ShipSettingsView_user_name": "Name",
  "ShipSettingsView_user_shortname": "Kurzname",
  "ShipSettingsView_user_account": "Account",
  "ShipSettingsView_user_active": "Aktivieren",
  "ShipSettingsView_user_inactive": "Deaktivieren",
  "ShipSettingsView_user_invite": "Einladen",
  "ShipSettingsView_user_invite_title": "Schiffs-User zu LOGBOOK einladen",
  "ShipSettingsView_user_reactivate": "Reaktivieren",
  "ShipSettingsView_remove_user": "Entfernen",
  "ShipSettingsView_user_deactivate_confirm_title": "User deaktivieren",
  "ShipSettingsView_user_deactivate_confirm_message": "Möchtest du den Zugriff dieses Users auf das Schiff wirklich deaktivieren? Falls er keinen anderen Schiffszugriff auf diesem Account hat, wird auch sein Account deaktiviert.",
  "ShipSettingsView_user_deactivate_confirm_accept": "Deaktivieren",
  "ShipSettingsView_user_deactivate_confirm_cancel": "Abbrechen",
  "ShipSettingsView_user_remove_confirm_title": "User entfernen",
  "ShipSettingsView_user_remove_confirm_message": "Möchtest du diesen User wirklich vom Schiff entfernen? Dies kann nicht rückgängig gemacht werden.",
  "ShipSettingsView_user_remove_confirm_accept": "Entfernen",
  "ShipSettingsView_user_remove_confirm_cancel": "Abbrechen",

  "ShipSettingsView_ship_user_level": "Berechtigungen",
  "ShipSettingsView_ship_user_level_primary": "Primär",
  "ShipSettingsView_ship_user_level_editAll": "Alles ansehen und bearbeiten",
  "ShipSettingsView_ship_user_level_editCurrent": "Aktuellen Törn ansehen und bearbeiten",
  "ShipSettingsView_ship_user_level_viewAll": "Alles ansehen",
  "ShipSettingsView_ship_user_level_viewCurrent": "Aktuellen Törn ansehen",
  "ShipSettingsView_ship_user_level_none": "Keine",

  "ShipSettingsView_user_status": "Status",
  "ShipSettingsView_user_status_active": "Aktiv",
  "ShipSettingsView_user_status_invited": "Eingeladen",
  "ShipSettingsView_user_status_undefined": " ",

  "ShipSettingsView_user_add_user": "Person hinzufügen",
  "ShipSettingsView_add_user_with_permissions": "Person mit Zugriffsrechten für LOGBOOK hinzufügen",
  "ShipSettingsView_add_user_without_permissions": "Person ohne Zugriffsrechte hinzufügen",
  "ShipSettingsView_users_with_level": "Schiffs-User mit Zugriffsrechten für LOGBOOK",
  "ShipSettingsView_users_without_level": "Personen ohne Zugriffsrechte",

  "ShipContentView": "",
  "ShipContentView_back": "Zurück",

  "ShipDataView": "",
  "ShipDataView_blank": "  ",
  "ShipDataView_": "*Auswählen*",
  "ShipDataView_add": "Hinzufügen",
  "ShipDataView_ship_data": "Schiffsdaten",
  "ShipDataView_file_field_drag_drop": "Füge hier Fotos deines Schiffs ein.",

  "ShipDataView_general": "Allgemeine Schiffsdaten",
  "ShipDataView_choose": "*Wählen/eingeben* ",
  "ShipDataView_other": "Anderes eingeben",

  "ShipDataView_tab_general": "Allgemein",
  "ShipDataView_tab_details": "Details",
  "ShipDataView_tab_technic": "Technik",
  "ShipDataView_tab_sailing": "Segeln",
  "ShipDataView_tab_equipment": "Ausrüstung",
  "ShipDataView_tab_ship_user": "Alle Personen",
  "ShipDataView_tab_units": "Einheiten",

  "ShipDataView_callsign": "Rufzeichen",
  "ShipDataView_imo": "IMO",
  "ShipDataView_mmsi": "MMSI",
  "ShipDataView_name": "Name",

  "ShipDataView_reg_number": "Registrierungsnummer",
  "ShipDataView_hin": "HIN",
  "ShipDataView_flag": "Flagge",
  "ShipDataView_home_port": "Heimathafen",
  "ShipDataView_yacht_club": "Yachtclub",
  "ShipDataView_yacht_club_address": "Adresse",

  "ShipDataView_model_name": "Modellname",
  "ShipDataView_year": "Baujahr",
  "ShipDataView_yachtbuilder": "Werft",
  "ShipDataView_designer": "Designer",
  "ShipDataView_construction": "Gesamtkonstruktion",
  "ShipDataView_build_number": "Baunummer",
  "ShipDataView_cel": "CEL-Kategorie",
  "ShipDataView_cel_persons": "für Personen",

  "ShipDataView_ship_foto": "Schiffsfoto",

  "ShipDataView_inside": "Wohnbereich",
  "ShipDataView_berth_no": "Anz. Kojen gesamt",
  "ShipDataView_berth_single_no": "Anz. Einzelkojen",
  "ShipDataView_berth_double_no": "Anz. Doppelkojen",
  "ShipDataView_berth_extra_no": "Anz. Zusatzkojen",
  "ShipDataView_cabins_no": "Anz. Kabinen",
  "ShipDataView_bath_no": "Anz. Bäder",
  "ShipDataView_saloon": "Salon",
  "ShipDataView_pantry": "Pantry",
  "ShipDataView_cabins": "Kabinen",
  "ShipDataView_cockpit": "Cockpit",

  "ShipDataView_owner": "Eigner",
  "ShipDataView_owner_name": "Name",
  "ShipDataView_owner_address": "Adresse",
  "ShipDataView_owner_phone": "Telefon",
  "ShipDataView_owner_email": "E-Mail",

  "ShipDataView_shape": "Form",
  "ShipDataView_monohull": "Einrumpf",
  "ShipDataView_catamaran": "Katamaran",
  "ShipDataView_trimaran": "Trimaran",

  "ShipDataView_sailing-sloop": "Segelboot Slup",
  "ShipDataView_sailing-ketch": "Segelboot Ketsch",
  "ShipDataView_sailing-classic": "Segelboot klassisch",
  "ShipDataView_sailing-cat": "Segelboot Katamaran",
  "ShipDataView_sailing-tri": "Segelboot Trimaran",
  "ShipDataView_sailing-longkeeler": "Segelboot Langkieler",
  "ShipDataView_motor-boat": "Motorboot",
  "ShipDataView_motor-cat": "Motor-Katamaran",
  "ShipDataView_motor-tri": "Motor-Trimaran",
  "ShipDataView_motor-yacht": "Motoryacht",
  "ShipDataView_motor-superyacht": "Motor-Superyacht",
  "ShipDataView_special_features": "Besonderheiten",

  "ShipDataView_vessel_type": "Schiffstyp",

  "ShipDataView_dimensions": "Abmessungen",
  "ShipDataView_height": "A: Höhe",
  "ShipDataView_draft": "B: Tiefgang",
  "ShipDataView_length_waterline": "C: Länge Wasserlinie",
  "ShipDataView_length_hull": "D: Länge Rumpf",
  "ShipDataView_length": "E: Länge über alles",
  "ShipDataView_beam": "Breite",
  "ShipDataView_hull_material": "Material des Rumpfs",
  "ShipDataView_hull_color": "Farbe des Rumpfs",
  "ShipDataView_masts_no": "Anz. der Masten",
  "ShipDataView_rig": "Form der Takelage",
  "ShipDataView_sail_area_total": "Segelfläche",
  "ShipDataView_comment": "Bemerkung",

  "ShipDataView_displacement": "Verdrängung",
  "ShipDataView_keel_weight": "Kielgewicht",
  "ShipDataView_keel_material": "Kielmaterial",
  "ShipDataView_ballast_percentage": "Ballastprozentsatz",
  "ShipDataView_keel_shape": "Kielform",
  "ShipDataView_keel_weight_percent": "Kielgewicht %",

  "ShipDataView_mast_rig": "Mast, Rigg und Deckausrüstung",
  "ShipDataView_rig_elements": "Rigg-Elemente",
  "ShipDataView_rig_element": "Rigg-Element",
  "ShipDataView_rig_mast": "Mast",
  "ShipDataView_rig_main_mast": "Großmast",
  "ShipDataView_rig_stay": "Toppstag",
  "ShipDataView_rig_mizzen_mast": "Besanmast",
  "ShipDataView_rig_forestay": "Vorstag",
  "ShipDataView_rig_jib_stay": "Klüverstag",
  "ShipDataView_rig_backstay": "Achterstag",
  "ShipDataView_rig_runner": "Runner",
  "ShipDataView_rig_baby_stay": "Babystag",
  "ShipDataView_rig_kicker": "Kicker",
  "ShipDataView_rig_vang": "Vang",
  "ShipDataView_rig_winch": "Winsch",
  "ShipDataView_rig_": "*Wählen/eingeben* ",
  "ShipDataView_rig_null": "*Wählen/eingeben* ",

  "ShipDataView_unit_m": "m",
  "ShipDataView_unit_cm": "cm",
  "ShipDataView_unit_inch": "inch",
  "ShipDataView_unit_foot": "foot",
  "ShipDataView_unit_yard": "yard",
  "ShipDataView_unit_nm": "sm",

  "ShipDataView_unit_m2": "m²",
  "ShipDataView_unit_square_foot": "sqft",
  "ShipDataView_unit_square_yard": "sqyd",

  "ShipDataView_unit_pound": "lb",
  "ShipDataView_unit_kg": "kg",
  "ShipDataView_unit_tons": "t",

  "ShipDataView_unit_knots": "kn",
  "ShipDataView_unit_m_per_second": "m/s",
  "ShipDataView_unit_km_per_hour": "km/h",
  "ShipDataView_unit_kWh": "kWh",
  "ShipDataView_unit_kw": "kW",
  "ShipDataView_unit_hp": "PS",

  "ShipDataView_unit_l": "l",
  "ShipDataView_unit_gal": "gal",
  "ShipDataView_unit_liter": "l",
  "ShipDataView_unit_gallon": "gal",
  "ShipDataView_unit_celsius": "°C",
  "ShipDataView_unit_fahrenheit": "°F",

  "ShipDataView_other_equipment": "Sonstige Ausrüstung",
  "ShipDataView_other_equipment_text": "Gebe hier alle sonstige Ausrüstung des Schiffes ein, die in den anderen Bereichen nicht eingegeben werden konnte, wie z.B. Angaben zum Beiboot etc.",

  "ShipDataView_add_engine": "Motor hinzufügen",
  "ShipDataView_add_generator": "Generator hinzufügen",
  "ShipDataView_add_sail": "Segel hinzufügen",
  "ShipDataView_add_insurance": "Versicherung hinzufügen",
  "ShipDataView_add_anchor": "Anker hinzufügen",
  "ShipDataView_add_tank": "Tank hinzufügen",
  "ShipDataView_add_steeringsystem": "Steuersystem hinzufügen",
  "ShipDataView_add_other_equipment": "Sonstige Ausrüstung hinzufügen",
  "ShipDataView_add_rig": "Rigg-Ausrüstung hinzufügen",
  "ShipDataView_nautical_add_device": "Gerät hinzufügen",
  "ShipDataView_safety_add_device": "Ausrüstung hinzufügen",
  "ShipDataView_electric_add_device": "Gerät hinzufügen",

  "ShipDataView_insurance": "Versicherung",
  "ShipDataView_insurances": "Versicherungen",
  "ShipDataView_insurance_": "*Wählen/eingeben* ",
  "ShipDataView_insurance_null": "*Wählen/eingeben* ",
  "ShipDataView_insurance_undefined": "*Wählen/eingeben* ",
  "ShipDataView_insurance_company": "Versicherungsgesellschaft",
  "ShipDataView_insurance_number": "Versicherungsnummer",
  "ShipDataView_insurance_type": "Art der Versicherung",
  "ShipDataView_insurance_hull": "Kasko",
  "ShipDataView_insurance_liability": "Haftpflicht",
  "ShipDataView_insurance_accident": "Unfall",

  "ShipDataView_engines": "Motoren",
  "ShipDataView_engine": "Motor",
  "ShipDataView_engine#": "Nr.",
  "ShipDataView_engine_nmea_number": "NMEA",
  "ShipDataView_engine_short_name": "Name (max. 10 Zeichen)",
  "ShipDataView_engine_": "*Wählen/eingeben* ",
  "ShipDataView_engine_undefined": "*Wählen/eingeben* ",
  "ShipDataView_engine_null": "*Wählen/eingeben* ",

  "ShipDataView_engine_outboard": "Außenborder",
  "ShipDataView_engine_saildrive": "Saildrive",
  "ShipDataView_engine_shaftdrive": "Wellenantrieb",
  "ShipDataView_engine_z_drive": "Z-Antrieb",
  "ShipDataView_engine_pod_drive": "Pod-Antrieb",
  "ShipDataView_engine_jet_drive": "Jet-Antrieb",

  "ShipDataView_generator_": "*Wählen/eingeben* ",
  "ShipDataView_generator_undefined": "*Wählen/eingeben* ",
  "ShipDataView_generator_null": "*Wählen/eingeben* ",

  "ShipDataView_generator": "Generator",
  "ShipDataView_generators": "Generatoren",
  "ShipDataView_generator_power_generator": "Stromgenerator",
  "ShipDataView_generator_warm_water": "Warmwasser",
  "ShipDataView_generator_watermaker": "Wasserentsalzung",
  "ShipDataView_generator_heating": "Heizung",
  "ShipDataView_generator_air_conditioning": "Klimaanlage",

  "ShipDataView_fuel_": "*Wählen/eingeben* ",
  "ShipDataView_fuel_null": "*Wählen/eingeben* ",
  "ShipDataView_fuel_undefined": "*Wählen/eingeben* ",
  "ShipDataView_fuel_type": "Treibstoff",
  "ShipDataView_fuel_diesel": "Diesel",
  "ShipDataView_fuel_petrol": "Benzin",
  "ShipDataView_fuel_gas": "Gas",
  "ShipDataView_fuel_electricity": "Elektrizität",

  "ShipDataView_drive_type_engine_null": "*Wählen/eingeben* ",
  "ShipDataView_number": "Nummer",
  "ShipDataView_manufacturer": "Hersteller",
  "ShipDataView_model": "Modell",
  "ShipDataView_serial_number": "Seriennummer",
  "ShipDataView_power": "Leistung",
  "ShipDataView_drive_type": "Antriebsart",
  "ShipDataView_propeller_type": "Propellertyp",

  "ShipDataView_steering_null": "*Wählen/eingeben* ",
  "ShipDataView_steering_systems": "Steuersysteme",
  "ShipDataView_steering_system_main": "Hauptsteuersystem",
  "ShipDataView_steering_": "*Wählen/eingeben* ",
  "ShipDataView_steering_type": "Steuerungstyp",
  "ShipDataView_rudder_no": "Anzahl Ruder",
  "ShipDataView_rudder_shape": "Form",
  "ShipDataView_rudder_drive": "Ruderantrieb",
  "ShipDataView_steering_bow_thruster": "Bugstrahlruder",
  "ShipDataView_steering_stern_thruster": "Heckstrahlruder",
  "ShipDataView_steering_self_steering": "Windfahnensteuerung",
  "ShipDataView_steering_windvane": "Windfahne",
  "ShipDataView_steering_trimtab": "Trimm-Ruder",
  "ShipDataView_steering_autopilot": "Autopilot",

  "ShipDataView_tanks": "Tanks",
  "ShipDataView_tanks_unit": "Tanks: ∑ ",
  "ShipDataView_tank": "Tankart",
  "ShipDataView_tank_": "*Wählen/eingeben* ",
  "ShipDataView_tank_undefined": "*Wählen/eingeben* ",
  "ShipDataView_tank_null": "*Wählen/eingeben* ",

  "ShipDataView_tank_fuel": "Treibstoff",
  "ShipDataView_tank_water": "Frischwasser",
  "ShipDataView_tank_gray": "Grauwasser",
  "ShipDataView_tank_waste": "Abwasser",
  "ShipDataView_tank_gas": "Gas",
  "ShipDataView_tank_fuel_daytank": "Treibstoff-Tagestank",

  "ShipDataView_tank_size": "Größe",
  "ShipDataView_tank_comment": "Kommentar",

  "ShipDataView_no": "Anzahl",
  "ShipDataView_tank_fuel_no": "Treibstoff: Anz. | ∑ Größe",
  "ShipDataView_tank_water_no": "Frischwasser: Anz. | ∑ Größe",
  "ShipDataView_tank_gray_no": "Grauwasser: Anz. | ∑ Größe",
  "ShipDataView_tank_waste_no": "Abwasser: Anz. | ∑ Größe",
  "ShipDataView_tank_gas_no": "Gas: Anz. | ∑ Größe",

  "ShipDataView_anchors": "Anker",
  "ShipDataView_anchor_type": "Ankertyp",
  "ShipDataView_anchor_": "*Wählen/eingeben* ",
  "ShipDataView_anchor_null": "*Wählen/eingeben* ",

  "ShipDataView_anchor_weight": "Gewicht",
  "ShipDataView_anchor_location": "Einbauort",

  "ShipDataView_bow": "Bug",
  "ShipDataView_stern": "Heck",
  "ShipDataView_variable": "variabel",

  "ShipDataView_anchor_chain": "Länge und Art der Kette",
  "ShipDataView_anchor_chain_lead": "Kettenlauf",
  "ShipDataView_anchor_windlass": "Ankerwinde",
  "ShipDataView_anchor_windless_drive": "Antrieb",
  "ShipDataView_anchor_windless_manfacturer": "Hersteller",

  "ShipDataView_anchor_spade": "Spaten-Anker",
  "ShipDataView_anchor_fishermans": "Stockanker",
  "ShipDataView_anchor_plough": "CQR/Pflugschar-Anker",
  "ShipDataView_anchor_danforth": "Danforth",
  "ShipDataView_anchor_rollerbar": "Rollenbar-Anker",

  "ShipDataView_manual": "manuell",
  "ShipDataView_electric": "elektrisch",

  "ShipDataView_watermaker": "Wasserentsalzung",
  "ShipDataView_batteries": "Batterien",
  "ShipDataView_batterie": "Batterie",
  "ShipDataView_capacity": "Kapazität",
  "ShipDataView_electrics": "Elektrik",
  "ShipDataView_date_purchase": "Kaufdatum",
  "ShipDataView_charger": "Ladegerät",
  "ShipDataView_inverter": "Wechselrichter",
  "ShipDataView_hot_water_boiler": "Warmwasserboiler",
  "ShipDataView_size": "Größe",
  "ShipDataView_size_height": "Größe/Höhe",

  "ShipDataView_place_installation": "Einbauort",
  "ShipDataView_date_installation": "Einbaudatum",

  "ShipDataView_devices": "Geräte",
  "ShipDataView_device": "Gerät",

  "ShipDataView_sails": "Segel",
  "ShipDataView_sail": "Segel",
  "ShipDataView_sail_": "*Wählen/eingeben* ",
  "ShipDataView_sail_null": "*Wählen/eingeben* ",

  "ShipDataView_sail_size": "Größe",
  "ShipDataView_sail_type": "Gesetzt auf",
  "ShipDataView_sail_reefs_no": "Anzahl Reffs",

  "ShipDataView_sail_mast": "Mast",
  "ShipDataView_sail_forestay": "Vorstag",
  "ShipDataView_sail_mizzen": "Besan",
  "ShipDataView_sail_mainsail": "Großsegel",
  "ShipDataView_sail_spinnaker": "Spinnaker",
  "ShipDataView_sail_genoa": "Genua",
  "ShipDataView_sail_jib": "Fock",
  "ShipDataView_sail_working_jib": "Arbeitsfock",
  "ShipDataView_sail_strom_jib": "Sturmfock",
  "ShipDataView_sail_mizzen_staysail": "Besanstag",
  "ShipDataView_sail_code0": "Code 0",
  "ShipDataView_sail_gennaker": "Gennaker",
  "ShipDataView_sail_try": "Trysegel",
  "ShipDataView_sail_storm_jib": "Sturmfock",
  "ShipDataView_sail_parasailor": "Parasailor",
  "ShipDataView_sail_0": "Keine",
  "ShipDataView_sail_1": "1",
  "ShipDataView_sail_2": "2",
  "ShipDataView_sail_3": "3",
  "ShipDataView_sail_reef_1": "Reff 1",
  "ShipDataView_sail_reef_2": "Reff 2",
  "ShipDataView_sail_reef_3": "Reff 3",
  "ShipDataView_sail_reef": "{sail} - {reef}",

  "ShipDataView_device_": "*Wählen/eingeben* ",
  "ShipDataView_device_undefined": "*Wählen/eingeben* ",
  "ShipDataView_device_nautical_": "*Wählen/eingeben* ",
  "ShipDataView_device_electric_": "*Wählen/eingeben* ",
  "ShipDataView_device_safety_": "*Wählen/eingeben* ",
  "ShipDataView_device_nautical_null": "*Wählen/eingeben* ",
  "ShipDataView_device_electric_null": "*Wählen/eingeben* ",
  "ShipDataView_device_safety_null": "*Wählen/eingeben* ",

  "ShipDataView_nautical_equipment": "Nautische Ausrüstung",
  "ShipDataView_safety_equipment": "Sicherheitsausrüstung",
  "ShipDataView_electric_equipment": "Elektrische Ausrüstung",

  "ShipDataView_device_nautical_analogue_compass": "Analoger Kompass",
  "ShipDataView_device_nautical_gyro_compass": "Kreiselkompass",
  "ShipDataView_device_nautical_fluxgate_compass": "Fluxgate-Kompass",
  "ShipDataView_device_nautical_satellite_compass": "Satelliten-Kompass",
  "ShipDataView_device_nautical_chart_plotter": "Kartenplotter",
  "ShipDataView_device_nautical_gps": "GPS",
  "ShipDataView_device_nautical_ais": "AIS-Transponder",
  "ShipDataView_device_nautical_radio": "Funkgerät",
  "ShipDataView_device_nautical_antenna": "Antenne",
  "ShipDataView_device_nautical_radar": "Radar",
  "ShipDataView_device_nautical_wind_gauge": "Windmesser",
  "ShipDataView_device_nautical_autopilot": "Autopilot",
  "ShipDataView_device_nautical_display_instruments": "Anzeige-Instrumente",
  "ShipDataView_device_nautical_fuel_gauge": "Treibstoffanzeige",
  "ShipDataView_device_nautical_battery_controller": "Batteriekontroller",
  "ShipDataView_device_nautical_hour_meter": "Betriebsstundenzähler",
  "ShipDataView_device_nautical_tachometer": "Drehzahlmesser",
  "ShipDataView_device_nautical_logger": "Logger",
  "ShipDataView_device_nautical_sounder": "Echolot",
  "ShipDataView_device_nautical_air_temperature": "Lufttemperatur",
  "ShipDataView_device_nautical_barometer": "Barometer",
  "ShipDataView_device_nautical_humidity": "Luftfeuchtigkeit",
  "ShipDataView_device_nautical_weather_receiver": "Wetterempfänger",
  "ShipDataView_device_nautical_nmea_gateway": "NMEA-Gateway",
  "ShipDataView_device_nautical_nmea_motor_adapter": "NMEA-Motoradapter",

  "ShipDataView_device_electric_battery": "Batterie",
  "ShipDataView_device_electric_inverter": "Wechselrichter",
  "ShipDataView_device_electric_charger": "Ladegerät",
  "ShipDataView_device_electric_solar_panel": "Solarpanel",
  "ShipDataView_device_electric_wind_generator": "Windgenerator",
  "ShipDataView_device_electric_watermaker": "Wasserentsalzung",

  "ShipDataView_device_safety_fire_extinguisher": "Feuerlöscher",
  "ShipDataView_device_safety_liferaft": "Rettungsinsel",
  "ShipDataView_device_safety_lifejacket": "Rettungsweste",
  "ShipDataView_device_safety_lifebelt": "Rettungsring",
  "ShipDataView_device_safety_lifeline": "Rettungsleine",
  "ShipDataView_device_safety_spare_propeller": "Ersatzpropeller",
  "ShipDataView_device_safety_emergency_tiller": "Notpinne",
  "ShipDataView_device_safety_bilge_pump_manual": "Handbilgepumpe",
  "ShipDataView_device_safety_bilge_pump_electric": "Elektrische Bilgepumpe",
  "ShipDataView_device_safety_shroud_cutter": "Wantenschneider",
  "ShipDataView_device_safety_radar_reflector": "Radarreflektor",
  "ShipDataView_device_safety_first_aid": "Erste Hilfe",
  "ShipDataView_device_safety_fire_blanket": "Feuerlöschdecke",
  "ShipDataView_device_safety_dinghy": "Beiboot ",
  "ShipDataView_device_safety_dinghy_motor": "Motor für Beiboot",
  "ShipDataView_device_safety_handheld_radio": "Handfunkgerät",
  "ShipDataView_device_safety_epirb": "Epirb",
  "ShipDataView_all_users": "Alle Personen für Crew usw.",

  "ShipEditView": "",
  "ShipEditView_name": "Name des Schiffes",
  "ShipEditView_name_min": "Name des Schiffes (mindestens 3 Zeichen)",
  "ShipEditView_title_edit": "Schiffsdaten für {ship}",
  "ShipEditView_title_new": "Neues Schiff erstellen",
  "ShipEditView_type": "Schiffstyp",
  "ShipEditView_type_motor": "Motorschiff",
  "ShipEditView_type_sailing": "Segelschiff",
  "ShipEditView_engines": "Anzahl Motoren",
  "ShipEditView_generators": "Anzahl Generatoren",
  "ShipEditView_create": "Schiff erstellen",
  "ShipEditView_cancel": "Abbrechen",
  "ShipEditView_choose": "Auswählen",
  "ShipEditView_print": "Schiffsdaten drucken",

  "ShipSelectView": "",
  "ShipSelectView_companion": "C",
  "ShipSelectView_view_logbook": "Anzeigen",
  "ShipSelectView_selecting": "Wird ausgewählt...",
  "ShipSelectView_options": "Optionen",
  "ShipSelectView_nearby": "Im Netzwerk gefunden",
  "ShipSelectView_nearby_hint": "Dieses Schiff wird in deinem aktuellen Netzwerk angeboten.",
  "ShipSelectView_unavailable_no_permission": "Du hast keine Berechtigung, dieses Schiff als Primary LOGBOOK zu öffnen.",
  "ShipSelectView_unavailable_import_in_progress": "Für dieses Schiff läuft noch ein Import.",

  "ShipSyncStatusView": "",
  "ShipSyncStatusView_close": "Schließen",
  "ShipSyncStatusView_retry": "Erneut versuchen",
  "ShipSyncStatusView_title": "Synchronisation mit LOGBOOK Cloud",

  "ShipUserSelect": "",
  "ShipUserSelect_add_user": "Person hinzufügen",
  "ShipUserSelect_dialog_add_new_user": "Neue Person hinzufügen",
  "ShipUserSelect_dialog_add_user": "Neue Person hinzufügen",
  "ShipUserSelect_dialog_add_user_name": "Name",
  "ShipUserSelect_dialog_add_user_shortname": "Kurzname",
  "ShipUserSelect_dialog_cancel": "Abbrechen",
  "ShipUserSelect_loading": "Wird geladen…",
  "ShipUserSelect_no_users": "Keine Personen verfügbar",
  "ShipUserSelect_select_additional_user": "+",
  "ShipUserSelect_select_user": "Person auswählen",

  "ShipView": "",

  "ShipView_add_cruise": "Törn",
  "ShipView_add_ship": "Schiff",
  "ShipView_empty_select": "Wähle zuerst ein Schiff aus.",

  "ShipView_import_trips_title": "Ältere Etappen aus LogbookSuite importieren",
  "ShipView_import_trips_choose": "Datei auswählen",
  "ShipView_import_trips_cancel": "Abbrechen",

  "ShipView_menu_action_title": "Neu",
  "ShipView_menu_NMEA": "NMEA",
  "ShipView_menu_now": "Fokus",
  "ShipView_menu_search": "Suchen",
  "ShipView_nmea_recording_disconnected": "NMEA getrennt",
  "ShipView_nmea_recording_error": "NMEA-Aufzeichnungsfehler:",
  "ShipView_nmea_recording_error_disconnected": "NMEA-Aufzeichnungsfehler: NMEA nicht verbunden",
  "ShipView_overlay_dismiss": "OK",
  "ShipView_overlay_missing_cruise": "Aufzeichnung kann nicht ohne aktiven Törn und aktive Etappe gestartet werden. Erstelle zuerst einen Törn.",
  "ShipView_overlay_missing_trip": "Aufzeichnung kann nicht ohne aktive Etappe gestartet werden. Erstelle zuerst eine Etappe.",
  "ShipView_ship_data": "Schiffsdaten",
  "ShipView_ship_settings": "Einstellungen",
  "ShipView_sync_initialSyncInProgress": "Initiale Synchronisation läuft",
  "ShipView_sync_settings": "Einstellungen",
  "ShipView_sync_uninitialized": "Vorbereitung zur Synchronisation",

  "ShipView_resync_cancel": "Abbrechen",
  "ShipView_resync_confirm_cancel": "Zurück",
  "ShipView_resync_confirm_execute": "Bestätigen",
  "ShipView_resync_title": "Unterbrochene Verbindung wiederherstellen",
  "ShipView_resync_reset_local": "Lokale Daten verwenden",
  "ShipView_resync_reset_cloud": "Cloud-Daten verwenden",
  "ShipView_resync_last_sync": "Dieses Gerät zuletzt synchronisiert",
  "ShipView_resync_cloud_updated": "LOGBOOK Cloud zuletzt aktualisiert",
  "ShipView_resync_status_failed": "Die LOGBOOK Cloud konnte nicht erreicht werden, daher ist der Verbindungsstatus unbekannt. Prüfe die Internetverbindung und versuche es erneut.",
  "ShipView_resync_permission_required": "Dein Cloud-Konto hat für dieses Schiff keine Primary-Berechtigung mehr. Synchronisierung und Wiederherstellung benötigen diese Berechtigung. Bitte den Schiffseigner, sie wiederherzustellen, und versuche dann erneut zu synchronisieren. Lass das Schiff geöffnet, um nicht synchronisierte lokale Änderungen zu erhalten; das Schließen der Cloud-Verbindung allein stellt die Berechtigung nicht wieder her.",
  "ShipView_resync_claimed_here": "Die LOGBOOK Cloud erkennt dieses Gerät weiterhin als Primary. Solange diese Verbindung aktiv ist, ist kein Zurücksetzen möglich. Versuche zuerst erneut zu synchronisieren. Falls ein Zurücksetzen weiterhin nötig ist, schließe das Schiff in der LOGBOOK Cloud, öffne diesen Dialog erneut und wähle die Daten, die du behalten möchtest. Lass das Schiff in dieser App bis zum Abschluss der Wiederherstellung geöffnet, um nicht synchronisierte lokale Änderungen zu erhalten.",
  "ShipView_resync_reset_failed": "Die Verbindung konnte nicht wiederhergestellt werden. Bitte versuche es erneut.",
  "ShipView_resync_reset_claimed": "Die Cloud hat die Wiederherstellung abgelehnt. Deine Berechtigung oder die Verbindung des Schiffs hat sich möglicherweise geändert. Gehe zurück und prüfe den aktuellen Status, bevor du es erneut versuchst.",
  "ShipView_read_more": "Weiterlesen",

  "StatsView": "",
  "StatsView_days_run": "Tagesetmal",
  "StatsView_distance_total": "Gesamtdistanz",
  "StatsView_distance_under_engine": "Distanz unter Motor",
  "StatsView_distance_under_engine_name": "{name}",
  "StatsView_distance_under_sails": "Distanz unter Segeln",
  "StatsView_duration_under_engine": "Zeit unter Motor",
  "StatsView_duration_under_engine_name": "{name}",
  "StatsView_duration_under_sails": "Zeit unter Segeln",
  "StatsView_speed": "Ø-Geschwindigkeit",
  "StatsView_time_total": "Gesamtzeit",
  "StatsView_time_total_paused_cruising": "Zeit: Gesamt | Pausen | Unterwegs",
  "StatsView_update": "Neu berechnen",

  "TrackView": "",
  "TrackView_no_track": "Kein Track verfügbar",

  "TripEditView": "",
  "TripEditView_cancel": "Abbrechen",
  "TripEditView_current_time": "Aktuelle Zeit",
  "TripEditView_dialog_title": "Etappe erstellen",
  "TripEditView_start": "Etappe starten",
  "TripEditView_timezone": "Zeitzone",
  "TripEditView_title": "Name der Etappe",

  "TripView": "",
  "TripView_tab_crew": "Crew",
  "TripView_tab_stats": "Statistik",
  "TripView_tab_track": "Track",
  "TripView_tab_trip": "Etappe",
  "TripView_tab_weather": "Wetter",
  "TripView_tab_print": "Drucken",
  "TripView_untitled_trip": "Etappe ohne Namen",
  "TripView_print_all": "Alle Etappen dieses Törns drucken",
  "TripView_print_trip": "Diese Etappe drucken",

  "UserAdviceAlertView": "",
  "UserAdviceAlertView_alert_acknowledged": "Bestätigt",
  "UserAdviceAlertView_alert_alarm": "Alarm",
  "UserAdviceAlertView_alert_anchorDrift": "Ankerdrift",
  "UserAdviceAlertView_alert_anchorDrift_short": "Drift",
  "UserAdviceAlertView_alert_default": "Unbekannt",
  "UserAdviceAlertView_alert_depth": "Tiefe",
  "UserAdviceAlertView_alert_depth_short": "Tiefe",
  "UserAdviceAlertView_alert_ignored": "Ignoriert",
  "UserAdviceAlertView_alert_lostPosition": "Position verloren",
  "UserAdviceAlertView_alert_lostPosition_short": "Position",
  "UserAdviceAlertView_alert_message": "Nachricht",
  "UserAdviceAlertView_alert_message_short": "Nachricht",
  "UserAdviceAlertView_alert_ok": "OK",
  "UserAdviceAlertView_alert_pressure": "Luftdruck",
  "UserAdviceAlertView_alert_pressure_short": "Luftdruck",
  "UserAdviceAlertView_alert_resolved": "Behoben",
  "UserAdviceAlertView_alert_test": "Test",
  "UserAdviceAlertView_alert_test_short": "Test",
  "UserAdviceAlertView_alert_warning": "Warnung",
  "UserAdviceAlertView_alert_wind": "Wind",
  "UserAdviceAlertView_alert_wind_short": "Wind",
  "UserAdviceAlertView_alert_lights": "Sichtzeichen",
  "UserAdviceAlertView_alert_lights_short": "Lichter",
  "UserAdviceAlertView_alert_manOverboard": "Mann über Bord",
  "UserAdviceAlertView_alert_manOverboard_short": "MOB",
  "UserAdviceAlertView_state_snoozed": "Geschlummert",
  "UserAdviceAlertView_state_acknowledged": "Bestätigt",
  "UserAdviceAlertView_state_audible": "Klingelt",
  "UserAdviceAlertView_close": "Schließen",
  "UserAdviceAlertView_record": "Ich habe {lighting} gesetzt",
  "UserAdviceAlertView_cancel": "Abbrechen",
  "UserAdviceAlertView_settings": "Einstellungen",
  "UserAdviceAlertView_submit": "Status setzen: {state}",
  "UserAdviceAlertView_submit_none": "Aktion wählen",
  "UserAdviceAlertView_state_snooze": "Geschlummert",
  "UserAdviceAlertView_state_acknowledge": "Bestätigt",
  "UserAdviceAlertView_state_clear": "Gelöscht",
  "UserAdviceAlertView_state_record": "Eingetragen",
  "UserAdviceAlertView_explain_snooze": "Schaltet den Alarm für einige Minuten stumm. Er bleibt offen und meldet sich erneut, wenn die Situation anhält.",
  "UserAdviceAlertView_explain_acknowledge": "Markiert den Alarm als gesehen und beendet den Ton. Er bleibt offen, bis sich die Situation klärt.",
  "UserAdviceAlertView_explain_clear": "Beendet den Alarm. Nur verwenden, wenn die Situation tatsächlich behoben ist.",
  "UserAdviceAlertView_explain_record": "Trägt die empfohlenen Sichtzeichen ins Logbuch ein. Die Erinnerung schließt sich von selbst, sobald die Sichtzeichen passt.",
  "UserAdviceAlertView_clear_denied": "Nur der Skipper oder die wachhabende Crew kann diesen Alarm löschen.",
  "UserAdviceAlertView_clear_confirm_message": "Beendet den Alarm für alle an Bord – unabhängig davon, ob die Situation noch besteht. Erst löschen, wenn sie tatsächlich behoben ist.",
  "UserAdviceAlertView_clear_confirm": "Alarm löschen",
  "UserAdviceAlertView_clear_confirm_cancel": "Zurück",
  "UserAdviceAlertView_escalate": "An Skipper eskalieren",
  "UserAdviceAlertView_state_escalate": "An Skipper eskaliert",
  "UserAdviceAlertView_explain_escalate": "Alarmiert den Skipper sofort, statt auf die automatische Eskalation zu warten. Eine Bestätigung oder ein Schlummern wird dabei aufgehoben, damit der Alarm ihn erreicht.",
  "UserAdviceAlertView_skip": "Überspringen",
  "UserAdviceAlertView_acknowledge": "Bestätigen",
  "UserAdviceAlertView_clear": "Löschen",
  "UserAdviceAlertView_snooze": "Schlummern",
  "UserAdviceAlertView_title": "Alarm {name} - {level}",
  "UserAdviceAlertView_error": "Die Aktion konnte nicht ausgeführt werden. Bitte versuche es erneut.",
  "UserAdviceAlertView_read_more": "Mehr anzeigen",

  "UserAdviceAnchorMonitorView": "",
  "UserAdviceAnchorMonitorView_cancel": "Abbrechen",
  "UserAdviceAnchorMonitorView_disable": "Deaktivieren",
  "UserAdviceAnchorMonitorView_enable": "Alarm aktivieren",
  "UserAdviceAnchorMonitorView_title_inactive": "Ankeralarm aus",
  "UserAdviceAnchorMonitorView_title_active": "Ankeralarm an",
  "UserAdviceAnchorMonitorView_title_short": "Ankeralarm",
  "UserAdviceAnchorMonitorView_method": "Methode",
  "UserAdviceAnchorMonitorView_method_fixedRadius": "Fester Radius",
  "UserAdviceAnchorMonitorView_method_rodeScope": "Kette / Scope",
  "UserAdviceAnchorMonitorView_method_sector": "Schwojsektor",
  "UserAdviceAnchorMonitorView_warning": "Warnung",
  "UserAdviceAnchorMonitorView_alarm": "Alarm",
  "UserAdviceAnchorMonitorView_rode": "Kette",
  "UserAdviceAnchorMonitorView_depth": "Tiefe",
  "UserAdviceAnchorMonitorView_boatLength": "Schiffslänge",
  "UserAdviceAnchorMonitorView_bearingFrom": "Von Peilung",
  "UserAdviceAnchorMonitorView_bearingTo": "Bis Peilung",
  "UserAdviceAnchorMonitorView_recenter": "Neu zentrieren",
  "UserAdviceAnchorMonitorView_save": "Speichern",
  "UserAdviceAnchorMonitorView_snooze": "Schlummern",
  "UserAdviceAnchorMonitorView_acknowledge": "Bestätigen",
  "UserAdviceAnchorMonitorView_clear": "Löschen",
  "UserAdviceAnchorMonitorView_keepAlive": "Im Hintergrund warnen",
  "UserAdviceAnchorMonitorView_depthWarning": "Tiefenwarnung",
  "UserAdviceAnchorMonitorView_depthAlarm": "Tiefenalarm",
  "UserAdviceAnchorMonitorView_error": "Der Ankeralarm konnte nicht aktualisiert werden. Bitte versuche es erneut.",
  "UserAdviceAnchorMonitorView_error_noPosition": "Der Ankeralarm braucht die aktuelle Position als Mittelpunkt, und im Moment liegt keine Position vor. Verbinde eine NMEA-GPS-Quelle (oder aktiviere das Geräte-GPS) und versuche es erneut.",
  "UserAdviceAnchorMonitorView_error_gpsPrecision": "Die aktuelle Position ist für den Ankeralarm nicht genau genug. Er braucht eine hochgenaue GPS-Quelle; das Geräte-GPS allein ist zu ungenau, um den Schwojkreis zu messen.",
  "UserAdviceAnchorMonitorView_error_noDay": "Der Ankeralarm kann erst gestartet werden, wenn der Tag begonnen hat und eine erste Position aufgezeichnet wurde. Deine Einstellungen wurden gespeichert; starte den Ankeralarm erneut, sobald das Logbuch aufzeichnet.",
  "UserAdviceAnchorMonitorView_read_more": "Mehr anzeigen",

  "UserAdviceEngineMissingView": "",
  "UserAdviceEngineMissingView_title_short": "Motor?",
  "UserAdviceEngineMissingView_title_castOff": "Motoreintrag fehlt?",
  "UserAdviceEngineMissingView_title_anchorUp": "Motoreintrag fehlt?",
  "UserAdviceEngineMissingView_title_motorVessel": "Motoreintrag fehlt?",
  "UserAdviceEngineMissingView_text_castOff": "Beim Ablegen wurde kein Motor erfasst. Lief der Motor?",
  "UserAdviceEngineMissingView_text_anchorUp": "Beim Ankerauf wurde kein Motor erfasst. Lief der Motor?",
  "UserAdviceEngineMissingView_text_motorVessel": "Das Schiff ist in Fahrt, ohne dass ein Motor erfasst wurde. Lief der Motor?",
  "UserAdviceEngineMissingView_all_engines": "Alle Motoren",
  "UserAdviceEngineMissingView_since_trigger": "Seit {time}",
  "UserAdviceEngineMissingView_since_now": "Ab jetzt",
  "UserAdviceEngineMissingView_started": "Motor lief",
  "UserAdviceEngineMissingView_sailing": "Nein, wir segeln",
  "UserAdviceEngineMissingView_sailing_noSails": "Kein Motor in Betrieb",
  "UserAdviceEngineMissingView_cancel": "Abbrechen",
  "UserAdviceDepthWatchView": "",
  "UserAdviceDepthWatchView_cancel": "Abbrechen",
  "UserAdviceDepthWatchView_disable": "Deaktivieren",
  "UserAdviceDepthWatchView_enable": "Alarm aktivieren",
  "UserAdviceDepthWatchView_title_inactive": "Tiefenalarm aus",
  "UserAdviceDepthWatchView_title_active": "Tiefenalarm an",
  "UserAdviceDepthWatchView_title_short": "Tiefenalarm",
  "UserAdviceDepthWatchView_snooze": "Schlummern",
  "UserAdviceDepthWatchView_acknowledge": "Bestätigen",
  "UserAdviceDepthWatchView_clear": "Löschen",
  "UserAdviceDepthWatchView_text": "Aktualisiere die Tiefenalarm-Schwellenwerte des Schiffs, die für jede Tiefenüberwachung gelten.",
  "UserAdviceDepthWatchView_save": "Speichern",
  "UserAdviceDepthWatchView_save_error": "Die Tiefenalarm-Einstellungen konnten nicht gespeichert werden. Bitte versuche es erneut.",
  "UserAdviceDepthWatchView_error": "Der Tiefenalarm konnte nicht aktualisiert werden. Bitte versuche es erneut.",

  "UserAdviceLightsReminderView": "",
  "UserAdviceLightsReminderView_title": "Sichtzeichen",
  "UserAdviceLightsReminderView_title_active": "Sichtzeichen-Erinnerung an",
  "UserAdviceLightsReminderView_title_inactive": "Sichtzeichen-Erinnerung aus",

  "UserAdviceManualShipStatusView": "",
  "UserAdviceManualShipStatusView_title_active": "Manueller Status bis {time}",
  "UserAdviceManualShipStatusView_title_short": "Manueller Status",
  "UserAdviceManualShipStatusView_text": "Die automatischen Statuswechsel sind abgeschaltet. Setze den Schiffsstatus selbst im Log-Menü — solange der manuelle Statusmodus aktiv ist, wird kein automatischer Log-Eintrag erzeugt.",
  "UserAdviceManualShipStatusView_remaining": "Endet um {time}, in etwa {minutes} Minuten — oder beim Tageswechsel, je nachdem was zuerst eintritt.",
  "UserAdviceManualShipStatusView_extend": "Verlängern",
  "UserAdviceManualShipStatusView_cancel": "Jetzt beenden",
  "UserAdviceManualShipStatusView_close": "Schließen",
  "UserAdviceManualShipStatusView_error": "Der manuelle Statusmodus konnte nicht aktualisiert werden. Bitte versuche es erneut.",

  "UserAdviceStopView": "",
  "UserAdviceStopView_cancel": "Abbrechen",
  "UserAdviceStopView_text": "Dokumentiere den Stopp. Tagesende pausiert die automatische Aufzeichnung, bis sich das Schiff wieder bewegt; beim Zwischenstopp bleibt sie aktiv.",
  "UserAdviceStopView_text_fixed_status": "Ergänze Tagesende oder Zwischenstopp, ohne den aktuellen Schiffsstatus zu ändern. Tagesende pausiert die automatische Aufzeichnung, bis sich das Schiff wieder bewegt; beim Zwischenstopp bleibt sie aktiv.",
  "UserAdviceStopView_end_location": "Ort",
  "UserAdviceStopView_end_of_day": "Tagesende",
  "UserAdviceStopView_manual_engine_entries": "Auch Motor(en) ausgeschaltet?",
  "UserAdviceStopView_manual_engine_entries_text": "Mit dem Aktivieren dieser Option wird gleichzeitig auch ein Endeintrag für den Motorbetrieb erstellt",
  "UserAdviceStopView_final_entry": "Endeintrag erstellen",
  "UserAdviceStopView_save": "Speichern",
  "UserAdviceStopView_status_anchor": "Ankerplatz",
  "UserAdviceStopView_status_buoy": "Boje",
  "UserAdviceStopView_status_port": "Hafen",
  "UserAdviceStopView_status_drifting": "Driften",
  "UserAdviceStopView_stopover": "Zwischenstopp",
  "UserAdviceStopView_status_lock": "Schleuse",
  "UserAdviceStopView_status_bunkering": "Tankstelle",
  "UserAdviceStopView_status_bridge": "Brücke",
  "UserAdviceStopView_status_waiting": "Warten",
  "UserAdviceStopView_stop_engines": "Eintrag für Motor(en) ausgeschaltet erstellen",
  "UserAdviceStopView_stop_type": "Stopptyp",
  "UserAdviceStopView_title": "Gestoppt",
  "UserAdviceStopView_title_duration": "Gestoppt seit {duration}",
  "UserAdviceStopView_title_short": "Gestoppt",
  "UserAdviceRow_collapse": "Weniger anzeigen",
  "UserAdviceRow_expand": "Alle Hinweise anzeigen",

  "UserSettingsView": "",
  "UserSettingsView_lang_en": "Englisch",
  "UserSettingsView_lang_de": "Deutsch",
  "UserSettingsView_lang_fr": "Französisch",
  "UserSettingsView_theme_dark": "Dunkel",
  "UserSettingsView_theme_light": "Classic",
  "UserSettingsView_theme_night": "Nacht",
  "UserSettingsView_theme_cloud": "Cloud",
  "UserSettingsView_language": "Sprache",
  "UserSettingsView_theme": "Farbschema",

  "UserSwitchView": "",
  "UserSwitchView_title": "User wechseln",
  "UserSwitchView_empty": "Für heute sind keine weiteren Crewmitglieder eingetragen.",

  "Mailer_trial_started_subject": "Dein LOGBOOK Trial wurde gestartet",
  "Mailer_trial_2daysleft_subject": "Deine LOGBOOK Trial-Phase endet bald",
  "Mailer_trial_expired_subject": "Deine LOGBOOK Trial-Phase ist beendet",
  "Mailer_subscription_expired_subject": "Dein LOGBOOK Abo ist abgelaufen",

  "LogButton": "",
  "LogButton_status": "Status",
  "LogButton_engines": "Motoren",
  "LogButton_generators": "Generatoren",
  "LogButton_lighting": "Sichtzeichen",
  "LogButton_lighting_none": "Keine Sichtzeichen",
  "LogButton_lighting_triColorLights": "Dreifarbenlaterne",
  "LogButton_lighting_anchorBall": "Ankerball",
  "LogButton_lighting_anchorLight": "Ankerlicht",
  "LogButton_lighting_sailingRunningLights": "Lichter unter Segeln",
  "LogButton_lighting_motoringRunningLights": "Lichter unter Maschine",
  "LogButton_lighting_navigationLights": "Navigationslichter",
  "LogButton_lighting_motoringCone": "Motorkegel",
  "LogButton_sails": "Segel",
  "LogButton_sails_confirm": "Segel speichern",
  "LogButton_sail_group_main": "Groß",
  "LogButton_sail_group_foresail": "Vorsegel",
  "LogButton_sail_group_spinnaker": "Spinnaker",
  "LogButton_sail_group_mizzen": "Besan",
  "LogButton_send_alert": "Alarm senden",
  "LogButton_man_overboard": "Mann über Bord",
  "LogButton_man_overboard_confirm_title": "Mann über Bord",
  "LogButton_man_overboard_confirm_message": "Dies alarmiert sofort die gesamte Crew, dass eine Person über Bord gegangen ist. Bitte nur bestätigen, wenn dies real ist.",
  "LogButton_man_overboard_confirm": "Alarm auslösen",
  "LogButton_man_overboard_cancel": "Abbrechen",
  "LogButton_man_overboard_error": "Der Mann-über-Bord-Alarm konnte nicht ausgelöst werden.",
  "LogButton_manual_status": "Manueller Status",
  "LogButton_manual_status_active": "Manueller Status an — ausschalten",
  "SendAlertDialog": "",
  "SendAlertDialog_title": "Alarm senden",
  "SendAlertDialog_users": "Crew-Mitglieder",
  "SendAlertDialog_add_user": "Crew-Mitglied hinzuf\u00FCgen",
  "SendAlertDialog_groups": "Wachgruppen",
  "SendAlertDialog_add_group": "Wachgruppe hinzuf\u00FCgen",
  "SendAlertDialog_message": "Nachricht",
  "SendAlertDialog_severity": "Schweregrad",
  "SendAlertDialog_severity_warning": "Warnung",
  "SendAlertDialog_severity_alarm": "Alarm",
  "SendAlertDialog_loudness": "Lautst\u00E4rke",
  "SendAlertDialog_loudness_audible": "Akustischer Alarm",
  "SendAlertDialog_loudness_notificationOnly": "Nur Benachrichtigung",
  "SendAlertDialog_error": "Der Alarm konnte nicht gesendet werden. Bitte versuche es erneut.",
  "SendAlertDialog_cancel": "Abbrechen",
  "SendAlertDialog_send": "Senden",
  "CatalogUserAdviceButton": "",
  "CatalogUserAdviceButton_notice": "Ankerwache aktiv",
  "CatalogUserAdviceButton_warning": "Wind nimmt zu",
  "CatalogUserAdviceButton_alarm": "Mann \u00FCber Bord!",
  "CatalogUserAdviceButton_short": "MOB",
  "CatalogUserAdviceButton_record": "Ankerlicht eintragen",
  "CatalogUserAdviceButton_primary-action": "Sichtzeichen",
  "CatalogUserAdviceButton_primary-action-denied": "Sichtzeichen",
  "CatalogUserAdviceRow": "",
  "CatalogUserAdviceRow_manOverboard": "Mann über Bord",
  "CatalogUserAdviceRow_manOverboard_short": "MOB",
  "CatalogUserAdviceRow_anchorDrift": "Ankerdrift",
  "CatalogUserAdviceRow_anchorDrift_short": "Drift",
  "CatalogUserAdviceRow_depth": "Tiefenalarm an",
  "CatalogUserAdviceRow_depth_short": "Tiefenalarm",
  "CatalogUserAdviceRow_lostPosition": "Position verloren",
  "CatalogUserAdviceRow_lostPosition_short": "Position",
  "CatalogUserAdviceRow_wind": "Windwarnung",
  "CatalogUserAdviceRow_wind_short": "Wind",
  "CatalogUserAdviceRow_stop": "Gestoppt seit 0:12:04",
  "CatalogUserAdviceRow_stop_short": "Gestoppt",
  "": ""
}
